<template>
  <section>
    <!-- <div id="sim" class="modal fade" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false">
      <div class="modal-dialog modal-md modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-body">
            <h2 class="bold text-danger text-center">SIM REGISTRATION ADVISORY!</h2>
            <p>To all our loan applicants and borrowers:</p>
            <p>SIM Registration is until July 25, 2023 only!</p>
            <p>Register your SIM cards and eSIMs now through the official links of our telco provider:</p>
            <p class="mb-0 ml-3"><b class="mr-2">•</b>SMART - <a href="https://simreg.smart.com.ph/" target="_blank">smart.com.ph/simreg</a> or <a href="https://simreg.smart.com.ph/" target="_blank">simreg.smart.com.ph</a></p>
            <p class="mb-0 ml-3"><b class="mr-2">•</b>GLOBE - <a href="https://new.globe.com.ph/simreg" target="_blank">new.globe.com.ph/simreg</a></p>
            <p class="ml-3"><b class="mr-2">•</b>DITO - <a href="https://digital.dito.ph/pto/download/app" target="_blank">https://digital.dito.ph/pto/download/app</a></p>
            <p>SIMs not registered within the said period shall be automatically
              DEACTIVATED.</p>
            <p>For concerns related to SIM Registration, call DICT at 1326.</p>
            <div class="text-center">
              <img src="images/sim-reg.jpg" alt="" class="img-fluid">
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" data-toggle="modal" data-target="#palawan" data-dismiss="modal" class="btn btn-primary px-4">Close</button>
          </div>
        </div>
      </div>
    </div> -->


    <div id="palawan" class="modal fade" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false">
      <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <!-- <h5 class="modal-title">Modal title</h5> -->
            <h4 class="bold mb-0 text-center">Pay your monthly amortization via Palawan Pawnshop using your Customer Account Number (CAN)!</h4>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="text-center">
              <!-- <h4 class="bold">Pay your monthly amortization via Palawan Pawnshop using your Customer Account Number (CAN)!</h4> -->
              <p class="px-md-4">Starting 30 June 2023, borrowers paying their monthly loan amortization with SBCorp via Palawan Pawnshop will need to indicate their Customer Account Number or CAN. Please log in to your BRS Account and click Loan Accounts to get your CAN.</p>
              <p class="mb-0">Pay only thru our accredited payment partners.</p>
              <p>Visit <a href="https://sbcorp.gov.ph/pay-your-loan-/ " target="_blank">https://sbcorp.gov.ph/pay-your-loan-/</a> for more information.</p>
            </div>
            <div class="text-center">
              <img src="images/palawan-advisory.png" alt="" class="img-fluid">
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" data-dismiss="modal" class="btn btn-primary px-4">Close</button>
          </div>
        </div>
      </div>
    </div>

    <div class="content-wrapper" v-if="$parent.prereg.completed == 1">
      <SecurityQuestion />
      <div id="overlay" v-if="processingAPI">
        <div class="spinner"></div>
        <span class="text-center badge bg-green fs-14" style="margin-top:110px;">Processing...</span>
      </div>
      <div id="overlay" v-if="uploadingAPI">
        <div class="spinner"></div>
        <span class="text-center badge bg-green fs-14" style="margin-top:110px;">Uploading...</span>
      </div>

      <div class="content-header">
        <div class="container-fluid">
          <div class="row">
            <div class="col-12">
              <h1>
                Dashboard
              </h1>
            </div>
          </div>
        </div>
      </div>



      <div class="content" v-if="exist_loan">
        <div class="content-fluid">
          <div class="row" v-show="!notif_id && !borrower_id && !application_id">
            <div class="col-12">
              <div class="card mb-0" style="border-radius: 0 !important;">
                <div class="card-header">
                  <h3 class="card-title bold">Notification<sup class="ml-1 badge badge-danger fs-12" v-if="notif.length > 0">{{notif.length}}</sup></h3>
                  <div class="card-tools">
                    <button type="button" class="pointer primary btn btn-tool" @click="toggling('AR')">
                      <i :class="[ toggle.AR ? 'fas fa-chevron-down' : 'fas fa-chevron-left' ]"></i>
                    </button>
                  </div>
                </div>
                <div class="card-body" v-show="toggle.AR">
                  <div class="table-responsive" v-if="notif.length > 0">
                    <table class="table table-sm">
                      <thead>
                        <th>Date</th>
                        <th>Application ID</th>
                        <th>Description</th>
                        <th>Action</th>

                      </thead>
                      <tbody>
                        <tr v-for="n in notif" :key="n.id">
                          <td>{{n.created_at | datetime}}</td>
                          <td>{{n.application_id}}</td>
                          <td>{{n.subject}}</td>
                          <td>
                            <button class="btn btn-sm btn-primary" @click="notifURL(n)">View</button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div class="alert alert-info2" v-else>
                    <i class="fas fa-info-circle mr-1 fs-15"></i>No available notification.
                  </div>
                </div>
              </div>
              <div class="card mb-0" style="border-radius: 0 !important;">
                <div class="card-header">
                  <h3 class="card-title bold">Transaction History</h3>
                  <div class="card-tools">
                    <button type="button" class="pointer primary btn btn-tool" @click="toggling('TH')">
                      <i :class="[ toggle.TH ? 'fas fa-chevron-down' : 'fas fa-chevron-left' ]"></i>
                    </button>
                  </div>
                </div>
                <div class="card-body" v-show="toggle.TH">
                  <div v-if="transact.length > 0">
                    <data-table :tblName="'trans-history'" :title="'Transaction History'" :columns="columns" :sortKey="sortKey" :sortOrders="sortOrders" @sort="sortBy" :pagination="pagination" @prev="getTransact(pagination.prevPageUrl)" @next="getTransact(pagination.nextPageUrl)">
                      <template v-slot:tbody>
                        <tbody>
                          <tr v-for="n in transact" :key="n.id">
                            <td>{{n.created_at | datetime}}</td>
                            <td>{{n.application_id}}</td>
                            <td>{{n.details}}</td>
                          </tr>
                        </tbody>
                      </template>
                      <template v-slot:rows class="no-print">
                        <span>Rows per page:</span>
                        <select class="form-control custom-select-sm ml-1" v-model="tableData.length" style="width: 65px !important;" @change="getTransact()">
                          <option v-for="(r, index) in rows" :key="index" :value="r">{{r}}</option>
                        </select>
                      </template>
                    </data-table>
                  </div>
                  <div class="alert alert-warning2" v-else>
                    <i class="fas fa-info-circle mr-1 fs-15"></i>Not available at the moment.
                  </div>
                </div>
              </div>
              <div class="card mb-0" style="border-radius: 0 !important;">
                <div class="card-header">
                  <h3 class="card-title bold">My Application</h3>
                  <div class="card-tools">
                    <button type="button" class="pointer primary btn btn-tool" @click="toggling('MA')">
                      <i :class="[ toggle.MA ? 'fas fa-chevron-down' : 'fas fa-chevron-left' ]"></i>
                    </button>
                  </div>
                </div>
                <div class="card-body" v-show="toggle.MA">
                  <div v-if="transact.length > 0">
                    <div class="table-responsive">
                      <table class="table table-sm">
                        <thead>
                          <th>Date</th>
                          <th>Application ID</th>
                          <th>Action</th>
                        </thead>
                        <tbody>
                          <tr v-for="(app, x) in forms" :key="x">
                            <td>{{app.updated_at | datetime}}</td>
                            <td>{{app.application_id}}</td>
                            <td>
                              <!-- <button class="btn btn-sm btn-primary" @click="viewForms(app)"><i class="fas fa-eye mr-1"></i>View</button> -->
                              <button class="btn btn-sm btn-primary" @click="viewForms(app)"><i class="fas fa-download mr-1"></i>Download</button>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div class="alert alert-warning2" v-else>
                    <i class="fas fa-info-circle mr-1 fs-15"></i>Not available at the moment.
                  </div>
                </div>
              </div>

              <div class="card mb-0" style="border-radius: 0 !important;" v-if="esign_attach || manual_attach">
                <div class="card-header">
                  <h3 class="card-title bold">Loan Releasing Documents</h3>
                  <div class="card-tools">
                    <button type="button" class="pointer primary btn btn-tool" @click="toggling('LR')">
                      <i :class="[ toggle.LR ? 'fas fa-chevron-down' : 'fas fa-chevron-left' ]"></i>
                    </button>
                  </div>
                </div>

                <div class="modal fade" id="modalPN" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false">
                  <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                    <div class="modal-content">
                      <div class="modal-header">
                        <h5 class="modal-title bold">PN Number: {{lr_title}}</h5>
                      </div>
                      <div class="modal-body">
                        <div v-for="(app, i) in lr_docs" :key="i">
                          <p>Application ID: {{i}}</p>

                          <div class="table-responsive">
                            <table class="table table-sm">
                              <thead>
                                <th>Date</th>
                                <th>Description</th>
                                <th>Action</th>
                              </thead>
                              <tbody v-if="esign_attach">
                                <tr v-for="(lr, x) in app" :key="x">
                                  <td>{{lr.updated_at | datetime}}</td>
                                  <td>{{lr.attach_desc}}</td>
                                  <td>
                                    <button class="btn btn-sm btn-primary" @click="lrURL(lr.filepath, lr.attach)"><i class="fas fa-download mr-1"></i>Download</button>
                                  </td>
                                </tr>
                              </tbody>
                              <tbody v-if="manual_attach">
                                <tr v-for="(lr, x) in app" :key="x">
                                  <td>{{lr.updated_at | datetime}}</td>
                                  <td>{{lr.enclosure_desc}}</td>
                                  <td>
                                    <button class="btn btn-sm btn-primary" @click="lrURL(lr.filepath, lr.enclose)"><i class="fas fa-download mr-1"></i>Download</button>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                      <div class="modal-footer">
                        <button type="button" class="btn btn-outline-primary" data-dismiss="modal">Close</button>
                      </div>
                    </div>
                  </div>
                </div>


                <div class="card-body" v-show="toggle.LR">
                  <div v-if="esign_attach">
                    <p class="card-text text-justify bold">Electronic Signatures</p>
                    <div class="table-responsive">
                      <table class="table table-sm">
                        <thead>
                          <th>PN Number</th>
                          <th>Action</th>
                        </thead>
                        <tbody>
                          <tr v-for="(lr, i) in esign_attach" :key="i">
                            <td>{{i}}</td>
                            <td>
                              <button class="btn btn-sm btn-primary" @click="modalPN(lr, i)"><i class="fas fa-eye mr-1"></i>View</button>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <hr v-if="esign_attach && manual_attach">
                  <div v-if="manual_attach">
                    <p class="card-text text-justify bold">Manual Signatures</p>
                    <div class="table-responsive">
                      <table class="table table-sm">
                        <thead>
                          <th>PN Number</th>
                          <th>Action</th>
                        </thead>
                        <tbody>
                          <tr v-for="(lr, i) in manual_attach" :key="i">
                            <td>{{i}}</td>
                            <td>
                              <button class="btn btn-sm btn-primary" @click="modalPN(lr, i)"><i class="fas fa-eye mr-1"></i>View</button>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>


              </div>
            </div>
          </div>
          <div class="row" v-show="notif_id && borrower_id && application_id && !update_profile">
            <div class="col-12">
              <div class="card">
                <div class="card-header">
                  <h3 class="card-title bold">For Compliance</h3>
                </div>
                <div class="card-body">
                  <div class="alert alert-info2 text-justify">
                    <i class="fas fa-info-circle mr-1 fs-15"></i>Please click the "View" button to see the requirements for each document.
                  </div>



                  <div class="table-responsive">
                    <table class="table table-sm">
                      <thead>
                        <th style="min-width: 200px!important;">Criteria</th>
                        <th>Details</th>
                        <th style="min-width: 250px!important;">Reason/s</th>
                        <th>Status</th>
                        <th style="min-width: 200px !important; max-width: 300px !important;">Action</th>
                      </thead>
                      <tbody>
                        <tr v-for="n in notif_detail" :key="n.id">
                          <td>{{n.doc_desc}}</td>
                          <td>
                            <button class="btn btn-outline-primary btn-sm" @click="showDetails(n.attach_code)">View</button>
                          </td>

                          <td v-if="subj_id == 1">{{n.reason_desc}}</td>
                          <td v-if="subj_id == 8 ">{{ checkReasonFPA(n.doc_code) }}</td>
                          <td>
                            <span v-if="n.status == 'CS01'" class="badge badge-primary">For Compliance</span>
                            <span v-else class="badge badge-success">Complied</span>
                          </td>
                          <td>
                            <div v-if="n.type==2">
                              <div v-if="n.status == 'CS01'" class="text-center">
                                <div class="input-group">
                                  <input type="text" class="form-control form-control-sm ro" @click="browseRef(n.attach_code)" readonly v-model="labelATT[n.attach_code]">
                                  <!-- <input type="file" v-if="n.attach_code =='ATT26' || n.attach_code =='ATT27' || n.attach_code =='ATT28'" hidden :id="n.attach_code" @change="uploadVideo($event, formATT, n.attach_code)"> -->
                                  <input type="file" v-if="n.attach_code =='ATT113' || n.attach_code =='ATT26' || n.attach_code =='ATT27' || n.attach_code =='ATT28'" hidden :id="n.attach_code" @change="uploadVideo($event, formATT, n.attach_code)">
                                  <input type="file" v-else hidden :id="n.attach_code" accept=".png, .jpg, .jpeg, .pdf" @change="uploadImgPdf($event, formATT, n.attach_code)">
                                  <div class="input-group-append">
                                    <button class="btn btn-sm btn-outline-primary" @click="browseRef(n.attach_code)">Browse</button>
                                    <button v-show="formATT[n.attach_code]" type="button" class="btn btn-sm btn-outline-success" @click="viewATT(formATT[n.attach_code], n.doc_desc)">View</button>
                                  </div>
                                </div>
                                <div v-if="progress[n.attach_code]">
                                  <div class="progress">
                                    <div class="progress-bar progress-bar-striped bg-success" role="progressbar" :style="'width:'+progress[n.attach_code]+ ';'">
                                      {{progress[n.attach_code]}}
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <i v-else class="fas fa-check success fs-20"></i>
                            </div>
                            <div v-if="n.type==1">
                              <button v-if="n.status == 'CS01'" class="btn btn-outline-primary btn-sm" @click="editModal(n.attach_code)"><i class="fas fa-edit mr-1"></i>Edit</button>
                              <i v-else class="fas fa-check success fs-20"></i>
                            </div>
                            <div v-if="n.type==3">
                              <button v-if="n.status == 'CS01'" class="btn btn-outline-primary btn-sm" @click="editModal2(n.attach_code)"><i class="fas fa-edit mr-1"></i>Edit</button>
                              <i v-else class="fas fa-check success fs-20"></i>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <hr>
                  <p class="fs-15"><em>Note: Please click the <b>"Submit"</b> button after completing the needed requirement/s.</em></p>
                </div>

                <div class="card-footer">
                  <button class="btn btn-outline-primary" @click="routeBack"><i class="fas fa-arrow-left mr-1"></i></i>Back</button>
                  <button class="btn btn-success float-right" @click="submitTag(subj_id)">Submit<i class="fas fa-arrow-right ml-1"></i></button>
                  <!-- <button class="btn btn-primary float-right mr-2" @click="saveTag"><i class="fas fa-save mr-1"></i>Save</button> -->
                </div>
              </div>
            </div>

          </div>



          <div class="row" v-if="notif_id && borrower_id && application_id && update_profile">
            <div class="col-md-1"></div>
            <div class="col-md-10">
              <div class="card">
                <div class="card-header">
                  <h3 class="card-title bold">Update Profile</h3>
                </div>
                <div class="card-body">
                  <div class="row">
                    <div class="col-md-4">
                      <div class="form-group">
                        <label>First Name</label>
                        <input class="form-control form-control-sm text-uppercase" type="text" v-model.trim="formName.fname" @input="formName.fname=$event.target.value.toUpperCase().trim()" @keypress="isName($event)" :class="{ 'is-invalid': submittedProfile && $v.formName.fname.$error }">
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="form-group">
                        <label>Middle Name</label>
                        <input class="form-control form-control-sm text-uppercase" type="text" v-model.trim="formName.mname" @input="formName.mname=$event.target.value.toUpperCase().trim()" @keypress="isName($event)" :class="{ 'is-invalid': submittedProfile && $v.formName.mname.$error }">
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="form-group">
                        <label>Last Name</label>
                        <input class="form-control form-control-sm text-uppercase" type="text" v-model.trim="formName.lname" @input="formName.lname=$event.target.value.toUpperCase().trim()" @keypress="isName($event)" :class="{ 'is-invalid': submittedProfile && $v.formName.lname.$error }">
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-sm-3">
                      <div class="form-group">
                        <label>Suffix</label>
                        <select class="custom-select-sm form-control text-uppercase" v-model='formName.suffix_code'>
                          <option :value="null" selected>- Select -</option>
                          <option v-for="data in suffix" :key="data.suffix_code" :value="data.suffix_code">{{data.suffix_desc}}</option>

                          <!-- <option value="2020001">I</option>
                          <option value="2020002">II</option>
                          <option value="2020003">III</option>
                          <option value="2020004">SR</option>
                          <option value="2020005">JR</option>
                          <option value="2020006">JRA</option>
                          <option value="2020007">IV</option>
                          <option value="2020008">V</option>
                          <option value="2020009">VI</option>
                          <option value="2020010">VII</option>
                          <option value="2020011">VIII</option>
                          <option value="2020012">IX</option>
                          <option value="2020013">X</option> -->
                        </select>
                      </div>
                    </div>
                    <div class="col-sm-3">
                      <div class="form-group">
                        <label>Birth Date</label>
                        <date-range-picker autocomplete="off" id="bdate" v-model="formName.date_birth" class="form-control form-control-sm" :start-date="date_birth" :max-date="maxBdate" :min-date="minBdate" v-input-mask data-inputmask-alias="datetime" :data-inputmask-max="maxBdate" :data-inputmask-min="minBdate" data-inputmask-inputformat="mm/dd/yyyy" placeholder="mm/dd/yyyy" :class="{ 'is-invalid': submittedProfile && $v.formName.date_birth.$error }"></date-range-picker>
                      </div>
                    </div>

                    <div class="col-sm-3">
                      <div class="form-group">
                        <label>Sex</label>
                        <select class="form-control custom-select-sm" v-model='formName.gender_id' :class="{ 'is-invalid': submittedProfile && $v.formName.gender_id.$error }">
                          <option selected disabled :value='null'>- Select -</option>
                          <option value="G202001">Male</option>
                          <option value="G202002">Female</option>
                        </select>
                      </div>
                    </div>

                    <div class="col-sm-3">
                      <div class="form-group">
                        <label>Civil Status</label>
                        <select class="form-control custom-select-sm text-uppercase" v-model='formName.cs_code' :class="{ 'is-invalid': submittedProfile && $v.formName.cs_code.$error }">
                          <option selected disabled :value='null'>- Select -</option>
                          <option value="CS001">Single</option>
                          <option value="CS002">Married</option>
                          <option value="CS003">Widowed</option>
                          <option value="CS004">Separated</option>
                          <option value="CS006">Annulled</option>
                        </select>
                      </div>

                    </div>
                  </div>

                  <div class="row">
                    <div class="col-sm-6">
                      <div class="form-group">
                        <label>Place of Birth <em>(Province)</em></label>
                        <v-select label="province" :options="provinces" :class="{'vs-invalid': submittedProfile && $v.formName.province_code_birth.$error }" :reduce="province => province.province_code" v-model="formName.province_code_birth" :clearable="false" @input="getCity(formName.province_code_birth), formName.place_birth=''"></v-select>
                      </div>
                    </div>
                    <div class="col-sm-6">
                      <div class="form-group">
                        <label><em>(City)</em></label>
                        <v-select label="city" :options="cities" :class="{'vs-invalid': submittedProfile && $v.formName.place_birth.$error }" :reduce="city => city.city_code" v-model="formName.place_birth" :clearable="false"></v-select>
                      </div>
                    </div>
                  </div>


                  <hr>

                  <p class="card-text text-justify bold">Residential Address</p>

                  <div class="row">
                    <div class="col-md-4">
                      <div class="form-group">
                        <label>Province</label>
                        <v-select placeholder="- Select -" label="province" :class="{'vs-invalid': submittedProfile && $v.formName.province_code.$error }" :options="provinces" :reduce="province => province.province_code" v-model="formName.province_code" @input="getCity2(formName.province_code), formName.city_code='', formName.bcode=''" :clearable="false"></v-select>
                      </div>
                    </div>

                    <div class="col-md-4">
                      <div class="form-group">
                        <label>City/Municipality</label>
                        <v-select placeholder="- Select -" label="city" :class="{'vs-invalid': submittedProfile && $v.formName.city_code.$error }" :options="cities2" :reduce="city => city.city_code" v-model="formName.city_code" :clearable="false" @input="getBrgy2(formName.city_code), formName.bcode=''"></v-select>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="form-group">
                        <label>Barangay</label>
                        <v-select placeholder="- Select -" label="bname" :class="{'vs-invalid': submittedProfile && $v.formName.bcode.$error }" :options="brgys2" :reduce="bname => bname.bcode" v-model="formName.bcode" :clearable="false"></v-select>
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-6">
                      <div class="form-group">
                        <label>House No/Block & Lot/Building</label>
                        <input type="text" class="form-control form-control-sm text-uppercase" :class="{ 'is-invalid': submittedProfile && $v.formName.bldg.$error }" @input="formName.bldg=$event.target.value.toUpperCase().trim()" v-model.trim="formName.bldg">
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label>Street Name / Subdivision</label>
                        <input type="text" class="form-control form-control-sm text-uppercase" :class="{ 'is-invalid': submittedProfile && $v.formName.street_address.$error }" @input="formName.street_address=$event.target.value.toUpperCase().trim()" v-model.trim="formName.street_address">
                      </div>
                    </div>
                  </div>

                  <hr>

                  <div class="row">
                    <div class="col-sm-4">
                      <div class="form-group">
                        <label>Goverment Issued I.D.</label>
                        <v-select label="id_name" :options="data_IDtypes" :reduce="id_name => id_name.id_code" :clearable="false" v-model="formName.id_code" :class="{'vs-invalid': submittedProfile && $v.formName.id_code.$error }">
                        </v-select>
                      </div>
                    </div>
                    <div class="col-sm-4">
                      <div class="form-group">
                        <label>I.D. Number</label>
                        <input type="text" class="form-control form-control-sm text-uppercase" @input="formName.id_number=$event.target.value.toUpperCase().trim()" v-model.trim="formName.id_number" :class="{ 'is-invalid': submittedProfile && $v.formName.id_number.$error }">
                      </div>
                    </div>
                    <div class="col-sm-4">
                      <div class="form-group">
                        <label>Expiry Date</label>
                        <date-range-picker autocomplete="off" id="id_issuedate" v-model="formName.expiry_date" class="form-control form-control-sm" :max-date="maxExpiry" :min-date="minExpiry" :start-date="today" v-input-mask data-inputmask-alias="datetime" :data-inputmask-max="maxExpiry" :data-inputmask-min="minExpiry" data-inputmask-inputformat="mm/dd/yyyy" placeholder="mm/dd/yyyy"></date-range-picker>
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-12">
                      <div class="alert alert-info2 text-justify">
                        <i class="fas fa-info-circle mr-1 fs-15"></i><strong>Note: </strong>
                        <span class="text-justify fs-15">Only accepts <b>png, jpg, jpeg file format</b>. If you’re using a computer or a laptop, you may only upload an existing photo. If you’re using your mobile phone/tablet/IPAD, you may either upload an existing photo or capture a new photo.</span>
                      </div>
                      <div class="attachment-block clearfix">
                        <div class="text-center">
                          <img :src="formName.ATT12" class="img-fluid" style="max-height: 300px!important; min-height:250px!important;" v-if="formName.ATT12">
                          <img class="img-fluid" src="images/image_placeholder.jpg" v-else>
                          <div v-show="submittedProfile && $v.formName.ATT12.$error " class="danger fs-13">Required</div>
                        </div>

                      </div>
                      <div class="text-center">
                        <label class="btn btn-sm btn-primary nowrap pointer mb0">
                          Browse/Capture
                          <input type="file" hidden @change="uploadImage12" accept=".png, .jpg, .jpeg">
                        </label>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="card-footer">
                  <button class="btn btn-outline-primary" @click="routeBack2"><i class="fas fa-arrow-left mr-1"></i></i>Back</button>
                  <button class="btn btn-success float-right" @click="updateNameID">Submit<i class="fas fa-arrow-right ml-1"></i></button>
                </div>
              </div>
            </div>
            <div class="col-md-1"></div>
          </div>
        </div>
      </div>

      <div class="content" v-else>
        <div class="content-fluid">
          <div class="row">
            <div class="col-md-3"></div>
            <div class="col-md-6">
              <div class="card">
                <div class="card-body">
                  <div class="row">
                    <div class="col-sm-12">
                      <p>Congratulations for creating a new account with us!
                        You are now eligible to apply a loan to Small Business Corporation,
                        if you want to proceed for loan processing just click the Apply for a
                        Loan button below,</p>
                      <p>or</p>
                      <p>You may view your profile or add your business information for us
                        to get to know you better.</p>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-sm-12">
                      <button class="btn btn-success btn-block" @click="goApplyLoan">Apply for a Loan</button>
                    </div>
                  </div>
                  <div class="row mt-2">
                    <div class="col-sm-12">
                      <button class="btn btn-success btn-block" @click="goProfile">My Profile</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-3"></div>
          </div>
        </div>
      </div>


      <div class="modal fade" id="modalProfile" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false">>
        <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title bold">DUPLICATE RECORD/S EXIST/S</h5>
            </div>
            <div class="modal-body">
              <div class="alert alert-danger text-justify">
                Our system has detected that there is/are existing record/s under this name. Kindly check and take note of the EMAIL ADDRESS with the CORRECT NAME. You will be logged out from the system and you would need to login using the email address you have selected.
              </div>

              <div class="table-responsive">
                <table class="table table-sm table-bordered">
                  <thead>
                    <th>Email</th>
                    <th>Name</th>
                    <th>Birthdate</th>
                    <th>Status</th>
                    <th>Action</th>
                  </thead>
                  <tbody>
                    <tr v-for="(u, index) in duplicates" :key="u.user_id">
                      <td class="nowrap">{{u.email}}</td>
                      <td class="nowrap">
                        <span v-if="u.suffix_desc">{{u.fname + ' ' + u.mname + ' ' + u.lname + ' ' + u.suffix_desc}}</span>
                        <span v-else>{{u.fname + ' ' + u.mname + ' ' + u.lname}}</span>
                      </td>
                      <td class="nowrap">{{u.date_birth | MM/DD/YYYY}}</td>
                      <td class="nowrap">
                        <span v-if="u.user_id == user.id" class="badge badge-success">Currently logged in</span>
                        <span v-else class="badge badge-primary">Active</span>
                      </td>
                      <td class="nowrap">
                        <div class="icheck-primary">
                          <input type="checkbox" v-bind:id="u.user_id" v-model="selectedAccount" :value="u" @change="selectedRow(u.user_id)" :disabled="selectedAccount.length >= 1 && u.user_id != selectedAccount[0].user_id">
                          <label v-bind:for="u.user_id"></label>
                        </div>
                      </td>
                    </tr>
                  </tbody>

                </table>
              </div>
            </div>
            <div class="modal-footer">
              <button class="btn btn-outline-primary" data-dismiss="modal">Cancel</button>
              <button class="btn btn-primary" @click="updateAccount">Update</button>
            </div>
          </div>
        </div>
      </div>


      <div class="modal fade" id="modalBank" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false">>
        <div class="modal-dialog modal-dialog-centered" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title bold">Update Bank Details</h5>
            </div>
            <div class="modal-body">


              <div class="form-group">
                <label>Manner of Release</label>
                <select ref="manner_rel" class="form-control custom-select-sm" @change="selectedMR" v-model="formBank.manner_rel" :class="{'is-invalid': submittedBank && $v.formBank.manner_rel.$error}">
                  <option :value="null" disabled selected>- Please Select -</option>
                  <option v-for="data in filteredMR" :key="data.manner_rel_code" :value="data.manner_rel_code">{{data.manner_rel_desc}}</option>
                </select>
              </div>
              <div class="form-group" v-if="formBank.manner_rel !='GC' && formBank.manner_rel !='PM'">
                <label>Bankname</label>
                <v-select label="bankname" :class="{'vs-invalid': submittedBank && $v.formBank.bankname.$error }" :options="filteredBank" :reduce="bankname => bankname.bankname" :clearable="false" v-model="formBank.bankname"></v-select>
              </div>
              <div class="form-group">
                <label>Account Name</label>
                <input type="text" class="form-control form-control-sm text-uppercase" v-model="formBank.acctname" :disabled="formBank.bt_code!='BT2020001'" :class="{'is-invalid': submittedBank && $v.formBank.acctname.$error}">
              </div>
              <div class="form-group">

                <div v-if="formBank.manner_rel =='GC' || formBank.manner_rel =='PM'">
                  <label>Registered Mobile Number</label>
                  <input type="text" ref="acctno" class="form-control form-control-sm text-uppercase" v-model="formBank.acctno" v-input-mask data-inputmask-mask="(9999) 9999999" data-inputmask-placeholder="" :class="{ 'is-invalid': submittedBank && $v.formBank.acctno.$error }">
                  <em class="fs-13">Ex. (0912) 3456789</em>
                  <p class="fs-13 danger m-0 p-0" v-if="submittedBank && $v.formBank.acctno.$error">Not a valid Mobile Number</p>
                </div>
                <div v-else>
                  <label>Account Number</label>
                  <input type="text" ref="acctno" class="form-control form-control-sm text-uppercase" v-model="formBank.acctno" @input="unmaskAcctNo" :class="{ 'is-invalid': submittedBank && $v.formBank.acctno.$error }">
                  <!-- <div v-show="formBank.manner_rel == 'FT' && formBank.bankname == 'LAND BANK OF THE PHILIPPINES' && checkAcctNo.charAt(3) != '6' &&  checkAcctNo.charAt(3) != '7'" class="danger fs-13"><em>For Fund Transfer (Landbank) – Account number should have 6 or 7 on the fourth digit of the account number</em></div> -->
                </div>
              </div>

              <hr>
              <div class="form-group">
                <p class="card-text text-justify fs-15"><em>Please upload here an evidence of your account name and number (e.g. screenshots from online apps, bank-validated deposit slip, ATM card with account name and account number, Passbook, etc.)</em></p>
                <div class="input-group">
                  <input type="text" class="form-control form-control-sm ro" @click="browseRef('ATT115')" readonly v-model="labelATT.ATT115" :class="{'is-invalid': submittedBank && !formATT.ATT115}">
                  <input type="file" hidden id="ATT115" accept=".png, .jpg, .jpeg, .pdf" @change="uploadImgPdf($event, formATT, 'ATT115')">
                  <div class="input-group-append">
                    <button class="btn btn-sm btn-outline-primary" @click="browseRef('ATT115')">Browse</button>
                    <button v-show="formATT.ATT115" type="button" class="btn btn-sm btn-outline-success" @click="viewATT(formATT.ATT115, 'Proof of Bank/EMA')">View</button>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button class="btn btn-outline-primary" data-dismiss="modal">Cancel</button>
              <button class="btn btn-primary" @click="updateBankDet">Update</button>
            </div>
          </div>
        </div>
      </div>

      <div class="modal fade" id="modalBank2" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false">>
        <div class="modal-dialog modal-dialog-centered" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title bold">Update Bank Details</h5>
            </div>
            <div class="modal-body">


              <div class="form-group">
                <label>Manner of Release</label>
                <select ref="manner_rel" class="form-control custom-select-sm" @change="selectedMR" v-model="formBank.manner_rel" :class="{'is-invalid': submittedBank && $v.formBank.manner_rel.$error}">
                  <option :value="null" disabled selected>- Please Select -</option>
                  <option v-for="data in filteredMR" :key="data.manner_rel_code" :value="data.manner_rel_code">{{data.manner_rel_desc}}</option>
                </select>
              </div>
              <div class="form-group" v-if="formBank.manner_rel !='GC' && formBank.manner_rel !='PM'">
                <label>Bankname</label>
                <v-select label="bankname" :class="{'vs-invalid': submittedBank && $v.formBank.bankname.$error }" :options="filteredBank" :reduce="bankname => bankname.bankname" :clearable="false" v-model="formBank.bankname"></v-select>
              </div>
              <div class="form-group">
                <label>Account Name</label>
                <input type="text" class="form-control form-control-sm text-uppercase" v-model="formBank.acctname" :disabled="formBank.bt_code!='BT2020001'" :class="{'is-invalid': submittedBank && $v.formBank.acctname.$error}">
              </div>
              <div class="form-group">

                <div v-if="formBank.manner_rel =='GC' || formBank.manner_rel =='PM'">
                  <label>Registered Mobile Number</label>
                  <input type="text" ref="acctno" class="form-control form-control-sm text-uppercase" v-model="formBank.acctno" v-input-mask data-inputmask-mask="(9999) 9999999" data-inputmask-placeholder="" :class="{ 'is-invalid': submittedBank && $v.formBank.acctno.$error }">
                  <em class="fs-13">Ex. (0912) 3456789</em>
                  <p class="fs-13 danger m-0 p-0" v-if="submittedBank && $v.formBank.acctno.$error">Not a valid Mobile Number</p>
                </div>
                <div v-else>
                  <label>Account Number</label>
                  <input type="text" ref="acctno" class="form-control form-control-sm text-uppercase" v-model="formBank.acctno" @input="unmaskAcctNo" :class="{ 'is-invalid': submittedBank && $v.formBank.acctno.$error }">
                  <!-- <div v-show="formBank.manner_rel == 'FT' && formBank.bankname == 'LAND BANK OF THE PHILIPPINES' && checkAcctNo.charAt(3) != '6' &&  checkAcctNo.charAt(3) != '7'" class="danger fs-13"><em>For Fund Transfer (Landbank) – Account number should have 6 or 7 on the fourth digit of the account number</em></div> -->
                </div>
              </div>

              <hr>
              <div class="form-group">
                <p class="card-text text-justify fs-15"><em>Please upload here an evidence of your account name and number (e.g. screenshots from online apps, bank-validated deposit slip, ATM card with account name and account number, Passbook, etc.)</em></p>
                <div class="input-group">
                  <input type="text" class="form-control form-control-sm ro" @click="browseRef('ATT22')" readonly v-model="labelATT.ATT22" :class="{'is-invalid': submittedBank && !formATT.ATT22}">
                  <input type="file" hidden id="ATT22" accept=".png, .jpg, .jpeg, .pdf" @change="uploadImgPdf($event, formATT, 'ATT22')">
                  <div class="input-group-append">
                    <button class="btn btn-sm btn-outline-primary" @click="browseRef('ATT22')">Browse</button>
                    <button v-show="formATT.ATT22" type="button" class="btn btn-sm btn-outline-success" @click="viewATT(formATT.ATT22, 'Proof of Bank/EMA')">View</button>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button class="btn btn-outline-primary" data-dismiss="modal">Cancel</button>
              <button class="btn btn-primary" @click="updateBankDet">Update</button>
            </div>
          </div>
        </div>
      </div>

      <div class="modal fade" id="modalCob" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false">
        <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title bold">Update Coborrower</h5>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label>First Name</label>
                    <input type="text" class="form-control form-control-sm text-uppercase" v-model.trim="formCob.fname" @input="formCob.fname=$event.target.value.toUpperCase().trim()" :class="{ 'is-invalid': submittedCob && $v.formCob.fname.$error }">
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label>Middlename</label>
                    <input type="text" class="form-control form-control-sm text-uppercase" v-model.trim="formCob.mname" @input="formCob.mname=$event.target.value.toUpperCase().trim()" :class="{ 'is-invalid': submittedCob && $v.formCob.mname.$error }">
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label>Lastname</label>
                    <input type="text" class="form-control form-control-sm text-uppercase" v-model.trim="formCob.lname" @input="formCob.lname=$event.target.value.toUpperCase().trim()" :class="{ 'is-invalid': submittedCob && $v.formCob.lname.$error }">
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="form-group">
                    <label for="">Suffix</label>
                    <select class="form-control custom-select-sm text-uppercase" v-model="formCob.suffix_code">
                      <option :value="null" selected>- Select -</option>
                      <option value="2020001">I</option>
                      <option value="2020002">II</option>
                      <option value="2020003">III</option>
                      <option value="2020004">SR</option>
                      <option value="2020005">JR</option>
                      <option value="2020006">JRA</option>
                      <option value="2020007">IV</option>
                      <option value="2020008">V</option>
                      <option value="2020009">VI</option>
                      <option value="2020010">VII</option>
                      <option value="2020011">VIII</option>
                      <option value="2020012">IX</option>
                      <option value="2020013">X</option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="">Relationship to the Borrower</label>
                    <select class="form-control custom-select custom-select-sm text-uppercase" v-model="formCob.relation_code" :class="{ 'is-invalid': submittedCob && $v.formCob.relation_code.$error }">
                      <option :value="null" selected disabled>- Select -</option>
                      <option v-for="data in data_relation" :key="data.relation_code" :value="data.relation_code">{{data.relation_desc}}</option>
                    </select>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="">Date of Birth</label>
                    <input type="date" class="form-control form-control-sm" v-model.trim="formCob.date_birth" :class="{ 'is-invalid': submittedCob && $v.formCob.date_birth.$error }">
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label>Government-Issued ID</label>
                    <v-select label="id_name" :class="{'vs-invalid': submittedCob && $v.formCob.id_code.$error }" :options="data_IDtypes" v-model="formCob.id_code" :reduce="id_name => id_name.id_code" :clearable="false">
                    </v-select>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="">ID Number</label>
                    <input type="text" class="form-control form-control-sm" v-model.trim="formCob.id_number" :class="{ 'is-invalid': submittedCob && $v.formCob.id_number.$error }">
                  </div>
                </div>
              </div>


              <hr>
              <div class="form-group">
                <div class="alert alert-warning2">
                  <i class="fas fa-info-circle mr-1 fs-15"></i><strong>Note: </strong>Only accepts png, jpg, jpeg and pdf file format.
                </div>
                <p class="card-text text-justify fs-15">Upload Co-borrower Government-Issued ID</p>
                <div class="input-group">
                  <input type="text" class="form-control form-control-sm ro" @click="browseRef('ATT29')" readonly v-model="labelATT.ATT29" :class="{'is-invalid': submittedCob && !formATT.ATT29}">
                  <input type="file" hidden id="ATT29" accept=".png, .jpg, .jpeg, .pdf" @change="uploadImgPdf($event, formATT, 'ATT29')">
                  <div class="input-group-append">
                    <button class="btn btn-sm btn-outline-primary" @click="browseRef('ATT29')">Browse</button>
                    <button v-show="formATT.ATT29" type="button" class="btn btn-sm btn-outline-success" @click="viewATT(formATT.ATT29, 'Coborrower Gov. ID')">View</button>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button class="btn btn-outline-primary" data-dismiss="modal">Cancel</button>
              <button class="btn btn-primary" @click="updateCob">Update</button>
            </div>
          </div>
        </div>
      </div>

      <div class="modal fade" id="modalGuide" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false">
        <div class="modal-dialog modal-dialog-centered" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title bold" v-if="guides2">{{guides2.title}}</h5>
            </div>
            <div class="modal-body">
              <ul>
                <li v-for="i in guides2.contents">{{i.label}}</li>
              </ul>
              <a v-if="guides2.code=='DOC01'" href="templatedFILE/Affidavit of Denial Template.docx" download>Download Affidavit of Denial Template</a>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-outline-primary" data-dismiss="modal">Close</button>
            </div>
          </div>
        </div>
      </div>


      <div class="modal fade" id="modalAppForm" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false">
        <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title bold">Loan Application Form</h5>
            </div>
            <div class="modal-body">
              <object :data="appForm.url+ '#view=FitH'" type="application/pdf" internalinstanceid="9" title="" width="100%" height="100%" v-if="appForm.url">
                <p>Your browser isn't supporting embedded pdf files. You can download the file.</p>
                <center><a href="javascript:void(0)" @click="downloadFile(appForm.url, 'SBC-Application-Form')" class="btn btn-sm btn-primary"><i class="fas fa-download mr-1"></i>Download File</a></center>
                <br>
              </object>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-outline-primary" @click="closeModalForms()">Close</button>
            </div>
          </div>
        </div>
      </div>

      <div class="modal fade" id="modalBusiness" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false">>
        <div class="modal-dialog modal-dialog-centered" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title bold">Update Business Information</h5>
            </div>
            <div class="modal-body">
              <div class="form-group">
                <label>Business Name</label>
                <input type="text" class="form-control form-control-sm text-uppercase" v-model="bus_info.business_name" :class="{ 'is-invalid': submittedBusName && $v.bus_info.business_name.$error }">
              </div>
            </div>
            <div class="modal-footer">
              <button class="btn btn-outline-primary" data-dismiss="modal">Cancel</button>
              <button class="btn btn-primary" @click="updateBusName">Update</button>
            </div>
          </div>
        </div>
      </div>


      <div class="modal fade" id="modalBusinessAdd" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false">>
        <div class="modal-dialog modal-dialog-centered" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title bold">Update Business Address</h5>
            </div>
            <div class="modal-body">
              <div class="form-group">
                <label>Business Name</label>
                <p class="card-text bold fs-17">{{bus_address.business_name}}</p>
                <!-- <input type="text" class="form-control form-control-sm text-uppercase" v-model="bus_info.business_name" :class="{ 'is-invalid': submittedBusAdd && $v.bus_info.business_name.$error }"> -->
              </div>
              <hr>
              <p class="card-text bold fs-17">Business Address</p>
              <div class="form-group">
                <label>Province</label>
                <v-select label="province" :class="{'vs-invalid': submittedBusAdd && $v.bus_address.province_code.$error }" :options="provinces" :reduce="province => province.province_code" v-model="bus_address.province_code" :clearable="false" @input="getCity(bus_address.province_code), bus_address.city_code='',  bus_address.bcode=''"></v-select>
              </div>
              <div class="form-group">
                <label>City/Municipality</label>
                <v-select label="city" :class="{'vs-invalid': submittedBusAdd && $v.bus_address.city_code.$error }" :options="cities" :reduce="city => city.city_code" v-model="bus_address.city_code" :clearable="false" @input="getBrgy(bus_address.city_code), bus_address.bcode=''"></v-select>
              </div>
              <div class="form-group">
                <label>Barangay</label>
                <v-select label="bname" :class="{'vs-invalid': submittedBusAdd && $v.bus_address.bcode.$error }" :options="brgys" :reduce="bname => bname.bcode" v-model="bus_address.bcode" :clearable="false"></v-select>
              </div>

              <div class="form-group">
                <label>House No/Block & Lot/Building</label>
                <input type="text" class="form-control form-control-sm text-uppercase" @input="bus_address.bldg=$event.target.value.toUpperCase().trim()" v-model.trim="bus_address.bldg" :class="{'is-invalid': submittedBusAdd && $v.bus_address.bldg.$error}">
              </div>
              <div class="form-group">
                <label>Street Name / Subdivision</label>
                <input type="text" class="form-control form-control-sm text-uppercase" @input="bus_address.street_address=$event.target.value.toUpperCase().trim()" v-model.trim="bus_address.street_address" :class="{'is-invalid': submittedBusAdd && $v.bus_address.street_address.$error}">
              </div>
            </div>
            <div class="modal-footer">
              <button class="btn btn-outline-primary" data-dismiss="modal">Cancel</button>
              <button class="btn btn-primary" @click="updateBusAddress">Update</button>
            </div>
          </div>
        </div>
      </div>

      <div class="modal fade" id="modalSSS13" role="dialog" data-backdrop="static" data-keyboard="false">
        <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title bold">Paid/SSS Validated Payment Reference Number (PRN)</h5>
            </div>
            <div class="modal-body">
              <div class="form-group">
                <label>Input Payment Reference Number (PRN)</label>
                <input type="text" class="form-control form-control-sm text-uppercase" v-model.trim="formSSS13.prn" :class="{'is-invalid': submittedSSS13 && $v.formSSS13.prn.$error}">
              </div>
              <div class="form-group">
                <label>Input PRN Statement Date</label>
                <input type="date" min="2022-01-01" max="2022-12-31" class="form-control form-control-sm" v-model.trim="formSSS13.state_date" :class="{'is-invalid': submittedSSS13 && $v.formSSS13.state_date.$error}">
              </div>
              <div class="form-group">
                <label>Input Number of Workers</label>
                <input type="text" class="form-control form-control-sm text-uppercase" v-model.trim="formSSS13.no_workers" :class="{'is-invalid': submittedSSS13 && $v.formSSS13.no_workers.$error}">
              </div>

              <div class="form-group">
                <label>Upload Payment Reference Number (PRN)</label>

                <div class="input-group">
                  <input type="file" hidden accept=".pdf" id="ATT136" @change="attachSSS13($event)">
                  <input type="text" v-if="formSSS13.ATT136" class="form-control form-control-sm ro" @click="browseRef('ATT136')" readonly :value="formSSS13.ATT136.name">
                  <input type="text" v-else class="form-control form-control-sm ro" readonly :value="'Choose a file..'" @click="browseRef('ATT136')" :class="{'is-invalid': submittedSSS13 && $v.formSSS13.ATT136.$error}">
                  <div class="input-group-append">
                    <button class="btn btn-sm btn-outline-primary" @click="browseRef('ATT136')">
                      <span v-if="formSSS13.ATT136">Change</span>
                      <span v-else>Attach</span>
                    </button>
                    <button v-if="formSSS13.ATT136" class="btn btn-sm btn-outline-primary ml-2" @click="viewSelectedFile(formSSS13.ATT136, formSSS13.ATT136.name)">View</button>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-outline-primary" @click='closeSSS13'>Cancel</button>
              <button type="button" class="btn btn-primary" @click="submitSSS13">Update</button>
            </div>
          </div>
        </div>
      </div>


      <div class="modal fade" id="modalBusReg" role="dialog" data-backdrop="static" data-keyboard="false">
        <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title bold">{{bus_reg}}</h5>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col-sm-8">
                  <div class="form-group">
                    <label>Place of Registration</label>
                    <div class="form-row">
                      <div class="col-sm-6">
                        <v-select placeholder="- Province -" label="province" class="pb-1" :class="{'vs-invalid': submitBus && $v.formBus.bus_reg_province.$error }" :options="provinces" :reduce="province => province.province_code" v-model="formBus.bus_reg_province" :clearable="false" @input="getCity(formBus.bus_reg_province), formBus.bus_reg_city = null;"></v-select>
                      </div>
                      <div class="col-sm-6">
                        <v-select placeholder="- City -" label="city" :class="{'vs-invalid': submitBus && $v.formBus.bus_reg_city.$error }" :options="cities" :reduce="city => city.city_code" v-model="formBus.bus_reg_city" :clearable="false"></v-select>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-md-4">
                  <div class="form-group">
                    <label>Date of Registration</label>
                    <date-range-picker v-if="reg_date" ref="reg_date" class="form-control form-control-sm" :class="{'is-invalid': submitBus && $v.formBus.bus_reg_date.$error}" id="bus_reg_date" v-model="formBus.bus_reg_date" :max-date="maxDate" :min-date="minDate" :start-date="startDate" v-input-mask data-inputmask-alias="datetime" :data-inputmask-max="maxStartDate" :data-inputmask-min="minStartDate" data-inputmask-inputformat="mm/dd/yyyy" placeholder="mm/dd/yyyy"></date-range-picker>
                  </div>
                </div>
              </div>


              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label>Business Expiration Date</label>
                    <date-range-picker v-if="reg_expiry" ref="reg_expiry" class="form-control form-control-sm" :class="{'is-invalid': submitBus && $v.formBus.bus_expiry.$error}" id="reg_expiry" v-model="formBus.bus_expiry" max-date="12/31/2099" :min-date="minDate" :start-date="startDate" v-input-mask data-inputmask-alias="datetime" data-inputmask-max="12/31/2099" :data-inputmask-min="minStartDate" data-inputmask-inputformat="mm/dd/yyyy" placeholder="mm/dd/yyyy"></date-range-picker>
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="form-group">
                    <label>Registration Number</label>
                    <input class="form-control form-control-sm" :class="{'is-invalid': submitBus && $v.formBus.bus_num.$error}" v-model="formBus.bus_num" />
                  </div>
                </div>



              </div>
              <div class="row">
                <div class="col-sm-12">
                  <div class="form-group">
                    <div class="alert alert-warning2">
                      <i class="fas fa-info-circle mr-1 fs-15"></i><strong>Note: </strong>Only accepts png, jpg, jpeg and pdf file format.
                    </div>
                    <p class="card-text text-justify fs-15">Scanned copy of the Original {{bus_reg}}</p>
                    <div class="input-group">
                      <input type="text" class="form-control form-control-sm ro" @click="browseRef(bus_reg_code)" readonly v-model="labelATT[bus_reg_code]" :class="{'is-invalid': submitBus && !formATT[bus_reg_code]}">
                      <input type="file" hidden :id="bus_reg_code" accept=".png, .jpg, .jpeg, .pdf" @change="uploadImgPdf($event, formATT, bus_reg_code)">
                      <div class="input-group-append">
                        <button class="btn btn-sm btn-outline-primary" @click="browseRef(bus_reg_code)">Browse</button>
                        <button v-show="formATT[bus_reg_code]" type="button" class="btn btn-sm btn-outline-success" @click="viewATT(formATT[bus_reg_code], bus_reg)">View</button>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-outline-primary" @click='closeBusReg'>Cancel</button>
              <button type="button" class="btn btn-primary" @click="postBusReg">Update</button>
            </div>
          </div>
        </div>
      </div>

      <div class="modal fade" id="modalStaple" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false">
        <div class="modal-dialog modal-dialog-centered" role="document">
          <div class="modal-content">
            <div class="modal-body">
              <p class="text-justify">Manner of Release</p>
              <div class="row">
                <div class="col-6 text-center">
                  <div class="icheck-primary d-inline">
                    <input type="radio" id="y" value="1" v-model="stapleRelease.rel_type">
                    <label for="y" :class="{'errorRadio': submittedPS && $v.stapleRelease.rel_type.$error}">Lumpsum</label>
                  </div>
                </div>
                <div class="col-6">
                  <div class="icheck-primary d-inline">
                    <input type="radio" id="n" value="2" v-model="stapleRelease.rel_type">
                    <label for="n" :class="{'errorRadio': submittedPS && $v.stapleRelease.rel_type.$error}">Tranches</label>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-outline-primary" data-dismiss="modal">Close</button>
              <button type="button" class="btn btn-primary" @click="submitStapleRelease()">Submit</button>
            </div>
          </div>
        </div>
      </div>


      <div class="modal fade" id="modalOdette" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false">
        <div class="modal-dialog modal-dialog-centered" role="document">
          <div class="modal-content">
            <div class="modal-body">
              <p class="text-justify">Manner of Release</p>
              <div class="row">
                <div class="col-6 text-center">
                  <div class="icheck-primary d-inline">
                    <input type="radio" id="y2" value="1" v-model="odetteRelease.rel_type">
                    <label for="y2" :class="{'errorRadio': submittedPS && $v.odetteRelease.rel_type.$error}">Lumpsum</label>
                  </div>
                </div>
                <div class="col-6">
                  <div class="icheck-primary d-inline">
                    <input type="radio" id="n2" value="2" v-model="odetteRelease.rel_type">
                    <label for="n2" :class="{'errorRadio': submittedPS && $v.odetteRelease.rel_type.$error}">Tranches</label>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-outline-primary" data-dismiss="modal">Close</button>
              <button type="button" class="btn btn-primary" @click="submitOdetteRelease()">Submit</button>
            </div>
          </div>
        </div>
      </div>

      <div class="modal fade" id="modalLoanDetailFT" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false">
        <div class="modal-dialog modal-dialog-centered" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title bold">Loan Detail</h5>
            </div>
            <div class="modal-body">
              <p class="text-justify bold">Approved Loan Details</p>
              <div class="table-responsive">
                <table class="table table-sm table-bordered">
                  <tbody>
                    <tr v-if="fpa_ft_loan.approved_loan_amt">
                      <td class="bold">Approved Loan Amount:</td>
                      <td>{{fpa_ft_loan.approved_loan_amt | currency}}</td>
                    </tr>
                    <tr>
                      <td class="bold">Loan Term (in months):</td>
                      <td>{{fpa_ft_loan.loan_term}}</td>
                    </tr>
                    <!-- <tr>
                      <td class="bold">Grace Period (in months):</td>
                      <td>{{fpa_ft_loan.grace_period}}</td>
                    </tr> -->
                  </tbody>
                </table>
              </div>
              <hr>
              <!-- <p class="text-justify">Would you like to request for a lower loan amount or change in the loan term and/or grace period?</p> -->
              <!-- <p class="text-justify">Would you like to change the loan term and/or grace period?</p> -->
              <p class="text-justify">Would you like to change the loan term?</p>
              <div class="row">
                <div class="col-6 text-center">
                  <div class="icheck-primary d-inline">
                    <input type="radio" id="y-ft" :value="1" v-model="formLoanFPA_FT.is_modified" @change="formLoanFPA_FT.loan_term=null">
                    <label for="y-ft" :class="{ 'errorRadio': submittedFPA_FT && $v.formLoanFPA_FT.is_modified.$error }">Yes</label>
                  </div>
                </div>
                <div class="col-6">
                  <div class="icheck-primary d-inline">
                    <input type="radio" id="n-ft" :value="0" v-model="formLoanFPA_FT.is_modified" @change="noModifyLoanFT">
                    <label for="n-ft" :class="{ 'errorRadio': submittedFPA_FT && $v.formLoanFPA_FT.is_modified.$error }">No</label>
                  </div>
                </div>
              </div>

              <div v-if="formLoanFPA_FT.is_modified">
                <hr>
                <div class="row">
                  <!-- <div class="col-md-12">
                                    <div class="form-group">
                                        <label>Loan Amount</label>
                                        <div class="input-group input-group-sm">
                                            <div class="input-group-prepend">
                                                <span class="input-group-text" style="background-color: transparent !important;">&#8369</span>
                                            </div>
                                            <input type="number" class="form-control" v-model="formLoanFPA_FT.loan_amount" :class="{'is-invalid': submittedFPA_FT && $v.formLoanFPA_FT.loan_amount.$error}" />
                                        </div>
                                    </div>
                                    <small class="text-grey float-right bold mt-n3">{{convertedAmount}}</small>
                                </div> -->
                  <div class="col-md-12">
                    <div class="form-group">
                      <label>Loan Term (in months)</label>
                      <select class="form-control custom-select-sm" v-model="formLoanFPA_FT.loan_term" :class="{'is-invalid': submittedFPA_FT && $v.formLoanFPA_FT.loan_term.$error}">
                        <option :value='null' disabled>- Select -</option>
                        <option v-for="n in arrLoanTerm" :value="n">{{ n }}</option>
                      </select>
                    </div>
                  </div>
                  <!-- <div class="col-md-12">
                    <div class="form-group">
                      <label>Grace Period (in months)</label>
                      <select class="form-control custom-select-sm" v-model="formLoanFPA_FT.grace_period" :class="{'is-invalid': submittedFPA_FT && $v.formLoanFPA_FT.grace_period.$error}">
                        <option :value='null' disabled>- Select -</option>
                        <option v-for="n in arrGracePeriod" :value="n">{{ n }}</option>
                      </select>
                    </div>
                  </div> -->
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-outline-primary" @click="cancelModalLoanDetailFT()">Cancel</button>
              <button type="button" class="btn btn-primary" @click="updateLoanFPA_FT">Submit</button>
            </div>
          </div>
        </div>
      </div>

      <div class="modal fade" id="modalCSA" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false">
        <div class="modal-dialog modal-dialog-centered" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title bold">Credit Checking Statement Compliance</h5>
            </div>
            <div class="modal-body">
              <div class="alert alert-info2">
                Kindly upload any of the following, as applicable:
                <ul>
                  <li>Certificate of Full Payment; and/or</li>
                  <li>Any document/s pertaining to on-going payment arrangement, resolution, and/or agreement of final settlement on said credit dealings (example: latest Statement of Accounts, proof of payment stipulated in the payment arrangement); and/or</li>
                  <li>Duly accomplished and Notarized Sworn Statement or Affidavit of Denial for accounts that you and/or your company are not the holder/s or party/ies of. (Please note that this requirement may not be applicable if based on our validation, the adverse credit findings are under your name).</li>
                </ul>
              </div>

              <div class="form-group">
                 <button class="btn btn-link p-0" @click="downloadSworn()">Sworn Statement Template (SST)</button>
              </div>

              <div class="form-group">
                <label>Upload duly accomplished (signed) and notarized Sworn Statement</label>
                <div class="input-group">
                  <input type="file" hidden accept=".pdf" id="doc01" @change="attachSworn($event)">
                  <input type="text" v-if="formCSA.DOC01" class="form-control form-control-sm ro" @click="browseRef('doc01')" readonly :value="formCSA.DOC01.name">
                  <input type="text" v-else class="form-control form-control-sm ro" readonly :value="'Choose a file..'" @click="browseRef('doc01')" :class="{'is-invalid': submittedSS && $v.formCSA.DOC01.$error}">
                  <div class="input-group-append">
                    <button class="btn btn-sm btn-outline-primary" @click="browseRef('doc01')">
                      <span v-if="formCSA.DOC01">Change</span>
                      <span v-else>Attach</span>
                    </button>
                    <button v-if="formCSA.DOC01" class="btn btn-sm btn-outline-primary ml-2" @click="viewSelectedFile(formCSA.DOC01, formCSA.DOC01.name)">View</button>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-outline-primary" data-dismiss="modal">Close</button>
              <button type="button" class="btn btn-primary" @click="submitSwornStatement()">Submit</button>
            </div>
          </div>
        </div>
      </div>

      <div class="modal fade" id="modalProofSale" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false">
        <div class="modal-dialog modal-dialog-centered" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title bold">For uploading of Proof of Sale</h5>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <div class="input-group">
                      <input type="file" hidden accept=".pdf" id="prof_sale" @change="attachProfSale($event)">
                      <input type="text" v-if="formProofSale.DOC05" class="form-control form-control-sm ro" @click="browseRef('prof_sale')" readonly :value="formProofSale.DOC05.name">
                      <input type="text" v-else class="form-control form-control-sm ro" readonly :value="'Choose a file..'" @click="browseRef('prof_sale')" :class="{'is-invalid': submittedPS && $v.formProofSale.DOC05.$error}">
                      <div class="input-group-append">
                        <button class="btn btn-sm btn-outline-primary" @click="browseRef('prof_sale')">
                          <span v-if="formProofSale.DOC05">Change</span>
                          <span v-else>Attach</span>
                        </button>
                        <button v-if="formProofSale.DOC05" class="btn btn-sm btn-outline-primary ml-2" @click="viewSelectedFile(formProofSale.DOC05, formProofSale.DOC05.name)">View</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-outline-primary" @click="closeModalProofSale">Close</button>
              <button type="button" class="btn btn-primary" @click="submitProofSale">Submit</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  import req_docs from "@json/req_docs.json";
  import guidelines from "@json/guidelines.json";
  import moment from "moment";
  import SecurityQuestion from "@components/public/Security/index.vue";
  import {
    Form
  } from "vform";
  import {
    required,
    requiredIf
  } from "vuelidate/lib/validators";
  export default {

    components: {
      SecurityQuestion
    },
    data() {
      let sortOrders = {};
      let columns = [{
          label: "Date",
          name: "created_at",
          show: true,
        },
        {
          label: "Application ID",
          name: "application_id",
          show: true,
        },
        {
          label: "Description",
          name: "details",
          show: true,
        },
      ];

      let column_names = columns.map((a) => a.name);

      columns.forEach((column) => {
        sortOrders[column.name] = -1;
      });

      return {
        suffix: [],
        fpa_ft_loan: [],
        formLoanFPA_FT: {
          application_id: null,
          is_modified: null,
          loan_term: null,
          grace_period: null,
          loan_amount: null,
        },
        submittedFPA_FT: false,

        option_curr: {
          currency: "USD",
          currencyDisplay: "hidden",
          valueRange: {
            min: 0,
            max: 10000000,
          },
        },

        res_arr: [],

        fpa_reason: [],

        formCSA: {
          DOC01: null,
          application_id: null,
          borrower_id: null,
          subj_id: null,
          notif_id: null,
        },

        forms: [],

        columns: columns,
        sortKey: "created_at",
        sortOrders: sortOrders,
        rows: ["10", "25", "50"],
        tableData: {
          length: 10,
          column: 0,
          dir: "desc",
          column_names: column_names,
          borrower_id: "",
          draw: 0,
        },
        pagination: {
          lastPage: "",
          currentPage: "",
          total: 0,
          lastPageUrl: "",
          nextPageUrl: "",
          prevPageUrl: "",
          from: 0,
          to: 0,
        },

        attachFile: {
          type: null,
          url: null,
        },
        req_docs: req_docs,
        today: moment().format("MM/DD/YYYY"),
        maxExpiry: "12/31/2040",
        minExpiry: "01/01/2000",
        minBdate: moment("01/01/1920", "MM/DD/YYYY"),
        maxBdate: moment().subtract(18, "years").format("MM/DD/YYYY"),
        date_birth: moment("01/01/1920", "MM/DD/YYYY"),
        // date_birth: null,

        maxDate: moment().format("MM/DD/YYYY"),
        minDate: moment("01/01/1900", "MM/DD/YYYY").format("MM/DD/YYYY"),
        startDate: moment().format("MM/DD/YYYY"),
        maxStartDate: moment().format("MM/DD/YYYY"),
        minStartDate: moment("01/01/1900", "MM/DD/YYYY").format("MM/DD/YYYY"),
        reg_date: false,
        reg_expiry: false,

        duplicates: [],
        selectedAccount: [],
        ids: [],
        ids2: [],

        bus_address: [],
        submittedBusAdd: false,

        guides2: [],

        guides: guidelines,

        appForm: {
          url: null,
          name: null,
        },

        formProofSale: new Form({
          application_id: null,
          borrower_id: null,
          notif_id: null,
          DOC05: null,
        }),

        formSSS13: new Form({
          prn: null,
          ATT136: null,
          state_date: null,
          no_workers: null,
        }),
        submittedSSS13: false,

        submittedCob: false,
        formCob: new Form({
          application_id: null,
          borrower_id: null,
          fname: null,
          lname: null,
          mname: null,
          notif_id: null,
          suffix_code: null,
          relation_code: null,
          id_code: null,
          id_number: null,
          date_birth: null,
          ATT29: null,
        }),

        formBus: new Form({
          application_id: null,
          borrower_id: null,
          bus_reg_province: null,
          bus_reg_city: null,
          bus_reg_date: null,
          bus_num: null,
          bus_expiry: null,
          ATT119: null,
          ATT120: null,
          ATT121: null,
        }),
        bus_reg_code: null,
        bus_reg: null,
        submitBus: false,

        submittedBank: false,
        checkAcctNo: "",
        formBank: new Form({
          application_id: null,
          req_loan_amt: null,
          manner_rel: null,
          bankname: null,
          acctname: null,
          acctno: null,
          ATT115: null,
          notif_id: null,
          bt_code: null,
          ATT22: null,
        }),

        recordExist: false,
        submittedProfile: false,

        submittedBusName: false,

        stapleRelease: new Form({
          borrower_id: null,
          application_id: null,
          rel_type: null,
          subj_id: null,
          notif_id: null,
        }),
        odetteRelease: new Form({
          borrower_id: null,
          application_id: null,
          rel_type: null,
          subj_id: null,
          notif_id: null,
        }),

        formName: new Form({
          borrower_id: null,
          notif_id: null,
          application_id: null,

          user_id: null,
          fname: null,
          lname: null,
          mname: null,
          suffix_code: null,
          date_birth: null,
          email: null,

          province_code_birth: null,
          place_birth: null, //city_code

          gender_id: null,
          cs_code: null,

          s_birthdate: null,
          bt_code: null,

          id_code: null,
          id_number: null,
          expiry_date: null,
          s_expiry_date: null,
          ATT12: null,

          province_code: null,
          city_code: null,
          bcode: null,
          bldg: null,
          street_address: null,
        }),

        uploadRRF: false,
        fileImage: [
          "image/jpeg",
          "image/png",
          "image/jpg",
          "image/JPEG",
          "image/PNG",
          "image/JPG",
        ],
        fileImagePdf: [
          "image/jpeg",
          "image/png",
          "image/jpg",
          "application/pdf",
          "image/JPEG",
          "image/PNG",
          "image/JPG",
          "application/PDF",
        ],
        fileVideo: [
          "video/MOV",
          "video/mov",
          "video/MPEG4",
          "video/mpeg4",
          "video/MP4",
          "video/mp4",
          "video/AVI",
          "video/avi",
          "video/WMV",
          "video/wmv",
          "video/MPEGPS",
          "video/mpegps",
          "video/FLV",
          "video/flv",
          "video/3GPP",
          "video/3ggp",
          "video/3GP",
          "video/3gp",
          "video/HEVC",
          "video/hevc",
          "video/WebM",
          "video/wbem",
          "video/DNxHR",
          "video/dnxhr",
          "video/ProRes",
          "video/prores",
          "video/CineForm",
          "video/cineform",
        ],
        fileSizeVideo: 1024 * 1024 * 110,
        upload: {
          uploading: false,

          ATT102: false,
          ATT103: false,
          ATT104: false,
          ATT105: false,
          ATT106: false,
          ATT107: false,
          ATT108: false,
          ATT109: false,
          ATT110: false,
          ATT111: false,
          ATT112: false,
          ATT113: false,
          ATT08: false,
          ATT115: false,
          ATT09: false,
          ATT10: false,

          ATT29: false,
          ATT117: false,
          ATT118: false,
          ATT119: false,
          ATT120: false,
          ATT121: false,
          ATT122: false,
          ATT123: false,
          ATT124: false,
          ATT125: false,
          ATT126: false,
          ATT127: false,
          DOC05: false,

          ATT22: false,
          ATT26: false,
          ATT27: false,
          ATT28: false,
          DOC01: false,
          ATT149: false,
          ATT143: false,
          ATT154: false,
          ATT155: false,
          ATT156: false,
        },
        progress: {
          ATT102: 0,
          ATT103: 0,
          ATT104: 0,
          ATT105: 0,
          ATT106: 0,
          ATT107: 0,
          ATT108: 0,
          ATT109: 0,
          ATT110: 0,
          ATT111: 0,
          ATT112: 0,
          ATT113: 0,
          ATT08: 0,
          ATT115: 0,
          ATT09: 0,
          ATT10: 0,
          ATT29: 0,
          ATT12: 0,
          DOC01: 0,
          ATT117: 0,
          ATT118: 0,
          ATT119: 0,
          ATT120: 0,
          ATT121: 0,
          ATT122: 0,
          ATT123: 0,
          ATT124: 0,
          ATT125: 0,
          ATT126: 0,
          ATT127: 0,

          ATT22: 0,
          ATT26: 0,
          ATT27: 0,
          ATT28: 0,

          ATT129: 0,
          ATT130: 0,
          ATT131: 0,
          ATT132: 0,
          ATT133: 0,
          ATT134: 0,
          ATT135: 0,
          ATT136: 0,
          ATT146: 0,
          ATT149: 0,
          ATT143: 0,
          ATT154: 0,
          ATT155: 0,
          ATT156: 0,
        },

        labelATT: {
          ATT102: "Choose a file...",
          ATT103: "Choose a file...",
          ATT104: "Choose a file...",
          ATT105: "Choose a file...",
          ATT106: "Choose a file...",
          ATT107: "Choose a file...",
          ATT108: "Choose a file...",
          ATT109: "Choose a file...",
          ATT110: "Choose a file...",
          ATT111: "Choose a file...",
          ATT112: "Choose a file...",
          ATT113: "Choose a file...",
          ATT08: "Choose a file...",
          ATT115: "Choose a file...",
          ATT09: "Choose a file...",
          ATT10: "Choose a file...",
          ATT29: "Choose a file...",
          ATT12: "Choose a file...",
          ATT117: "Choose a file...",
          ATT118: "Choose a file...",
          DOC01: "Choose a file...",
          ATT119: "Choose a file...",
          ATT120: "Choose a file...",
          ATT121: "Choose a file...",
          ATT122: "Choose a file...",
          ATT123: "Choose a file...",
          ATT124: "Choose a file...",
          ATT125: "Choose a file...",
          ATT126: "Choose a file...",
          ATT127: "Choose a file...",

          ATT22: "Choose a file...",
          ATT26: "Choose a file...",
          ATT27: "Choose a file...",
          ATT28: "Choose a file...",

          ATT129: "Choose a file...",
          ATT130: "Choose a file...",
          ATT131: "Choose a file...",
          ATT132: "Choose a file...",
          ATT133: "Choose a file...",
          ATT134: "Choose a file...",
          ATT135: "Choose a file...",
          ATT136: "Choose a file...",
          ATT149: "Choose a file...",
          ATT143: "Choose a file...",
          ATT146: "Choose a file...",
          ATT154: "Choose a file...",
          ATT155: "Choose a file...",
          ATT156: "Choose a file...",
        },

        formATT: {
          ATT102: null,
          ATT103: null,
          ATT104: null,
          ATT105: null,
          ATT106: null,
          ATT107: null,
          ATT108: null,
          ATT109: null,
          ATT110: null,
          ATT111: null,
          ATT112: null,
          ATT113: null,
          ATT08: null,
          ATT115: null,
          ATT09: null,
          ATT10: null,

          ATT29: null,
          ATT12: null,
          DOC01: null,

          ATT117: null,
          ATT118: null,
          ATT119: null,
          ATT120: null,
          ATT121: null,
          ATT122: null,
          ATT123: null,
          ATT124: null,
          ATT125: null,
          ATT126: null,
          ATT127: null,

          ATT22: null,
          ATT26: null,
          ATT27: null,
          ATT28: null,

          ATT129: null,
          ATT130: null,
          ATT131: null,
          ATT132: null,
          ATT133: null,
          ATT134: null,
          ATT135: null,
          ATT136: null,
          ATT146: null,
          ATT149: null,
          ATT143: null,
          ATT154: null,
          ATT155: null,
          ATT156: null,
        },

        fetchATT: {
          ATT102: null,
          ATT103: null,
          ATT104: null,
          ATT105: null,
          ATT106: null,
          ATT107: null,
          ATT108: null,
          ATT109: null,
          ATT110: null,
          ATT111: null,
          ATT112: null,
          ATT113: null,
          ATT08: null,
          ATT115: null,
          ATT09: null,
          ATT10: null,

          ATT29: null,
          ATT12: null,
          DOC01: null,

          ATT117: null,
          ATT118: null,
          ATT119: null,
          ATT120: null,
          ATT121: null,
          ATT122: null,
          ATT123: null,
          ATT124: null,
          ATT125: null,
          ATT126: null,
          ATT127: null,

          ATT22: null,
          ATT26: null,
          ATT27: null,
          ATT28: null,

          ATT129: null,
          ATT130: null,
          ATT131: null,
          ATT132: null,
          ATT133: null,

          ATT134: null,
          ATT135: null,
          ATT136: null,
          ATT149: null,
          ATT143: null,
          ATT154: null,
          ATT155: null,
          ATT156: null
        },

        notif_id: this.$route.query.n,
        borrower_id: this.$route.query.b,
        application_id: this.$route.query.a,
        update_profile: this.$route.query.update,
        subj_id: this.$route.query.subj_id,

        notif: [],
        notif_detail: [],
        transact: [],
        data_manner_rel: [],
        data_banks: [],
        data_IDtypes: [],
        bus_info: {
          business_name: null,
          id: null,
          bt_code: null,
        },
        business_file: null,
        doc_code: null,
        exist_loan: null,
        for_settlement: false,

        provinces: [],
        cities: [],
        brgys: [],

        cities2: [],
        brgys2: [],

        data_relation: [],

        formBorrower: new Form({
          user_id: null,
          borrower_id: null,
          fname: null,
          lname: null,
          mname: null,
          suffix_code: null,
          suffix_desc: null,
          date_birth: null,
          email: null,

          province_code_birth: null,
          place_birth: null, //city_code

          gender_id: null,
          cs_code: null,

          s_birthdate: null,
        }),

        bt_code: null,

        user: new Form({
          id: null,
          firstname: null,
          lastname: null,
          birthdate: null,
          bus_type: null,
          suffix_code: null,
          domain: null,
        }),

        toggle: {
          AR: false,
          TH: false,
          LR: false,
          MA: false,
        },

        api: {
          preReg: false,
          bor_det: false,
          user: false,
          notif: false,
          bank: false,
          update_profile: false,
          cob: false,
          update: false,
          transact: false,
          form: false,
          id_types: false,
          city: false,
          prov: false,
          lr: false,
          brgy: false,
        },
        submittedPS: false,
        submittedSS: false,

        remain_detail: [],
        filePDF: ["application/pdf", "application/PDF"],
        fileImage: [
          "image/jpeg",
          "image/png",
          "image/jpg",
          "image/JPEG",
          "image/PNG",
          "image/JPG",
        ],

        esign_attach: null,
        manual_attach: null,
        lr_docs: [],
        lr_title: null,
      }; //return
    }, //data
    validations: {
      formLoanFPA_FT: {
        is_modified: {
          required,
        },
        // loan_amount: {
        //     required: requiredIf(function(obj) {
        //         return obj.is_modified == 1;
        //     })
        // },
        loan_term: {
          required: requiredIf(function(obj) {
            return obj.is_modified == 1;
          }),
        },
        // grace_period: {
        //   required: requiredIf(function(obj) {
        //     return obj.is_modified == 1;
        //   }),
        // },
      },

      odetteRelease: {
        rel_type: {
          required,
        },
      },
      stapleRelease: {
        rel_type: {
          required,
        },
      },
      formBus: {
        bus_reg_province: {
          required,
        },
        bus_reg_city: {
          required,
        },
        bus_num: {
          required,
        },
        bus_expiry: {
          required,
        },
        bus_reg_date: {
          required,
        },
        ATT119: {
          required: requiredIf(function() {
            return this.bus_reg_code == "ATT119";
          }),
        },
        ATT120: {
          required: requiredIf(function() {
            return this.bus_reg_code == "ATT120";
          }),
        },
        ATT121: {
          required: requiredIf(function() {
            return this.bus_reg_code == "ATT121";
          }),
        },
      },

      formBank: {
        manner_rel: {
          required,
        },
        bankname: {
          required: requiredIf(function() {
            return (
              this.formBank.manner_rel == "FT" ||
              this.formBank.manner_rel == "IP" ||
              this.formBank.manner_rel == "PN"
            );
          }),
        },
        acctname: {
          required,
        },
        acctno: {
          required,
        },
        ATT115: {
          required: requiredIf(function() {
            return !this.formATT.ATT22;
          }),
        },
        ATT22: {
          required: requiredIf(function() {
            return !this.formATT.ATT115;
          }),
        },
      },
      formCob: {
        fname: {
          required,
        },
        mname: {
          required,
        },
        lname: {
          required,
        },
        relation_code: {
          required,
        },
        id_code: {
          required,
        },
        id_number: {
          required,
        },
        date_birth: {
          required,
        },
        ATT29: {
          required,
        },
      },
      formName: {
        fname: {
          required,
        },
        mname: {
          required,
        },
        lname: {
          required,
        },
        date_birth: {
          required,
        },
        gender_id: {
          required,
        },
        cs_code: {
          required,
        },
        id_code: {
          required,
        },
        id_number: {
          required,
        },
        ATT12: {
          required,
        },
        province_code_birth: {
          required,
        },
        place_birth: {
          required,
        },
        province_code: {
          required,
        },
        city_code: {
          required,
        },
        bcode: {
          required,
        },
        bldg: {
          required,
        },
        street_address: {
          required,
        },
      },
      bus_info: {
        business_name: {
          required,
        },
      },
      bus_address: {
        bcode: {
          required,
        },
        province_code: {
          required,
        },
        city_code: {
          required,
        },
        bldg: {
          required,
        },
        street_address: {
          required,
        },
      },

      formCSA: {
        DOC01: {
          required,
        },
      },

      formSSS13: {
        ATT136: {
          required,
        },
        prn: {
          required,
        },
        state_date: {
          required,
        },
        no_workers: {
          required,
        },
      },
      formProofSale: {
        DOC05: {
          required,
        },
      },
    },

    methods: {
      noModifyLoanFT() {
        this.formLoanFPA_FT.loan_term = this.fpa_ft_loan.loan_term;
        this.formLoanFPA_FT.grace_period = this.fpa_ft_loan.grace_period;
        this.formLoanFPA_FT.loan_amount = this.fpa_ft_loan.approved_loan_amt;
      },
      cancelModalLoanDetailFT() {
        this.formLoanFPA_FT.application_id = null;
        this.formLoanFPA_FT.is_modified = null;
        this.formLoanFPA_FT.loan_term = null;
        this.formLoanFPA_FT.grace_period = null;
        this.formLoanFPA_FT.loan_amount = null;
        $("#modalLoanDetailFT").modal("hide");
      },
      thousands_separators(num) {
        if (num) {
          let num_parts = num.toString().split(".");
          num_parts[0] = num_parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
          return num_parts.join(".");
        }
      },
      updateLoanFPA_FT: _.debounce(function() {
        this.submittedFPA_FT = true;
        this.$v.formLoanFPA_FT.$touch();
        this.formLoanFPA_FT.loan_amount = this.fpa_ft_loan.approved_loan_amt ? this.fpa_ft_loan.approved_loan_amt : this.fpa_ft_loan.rec_loan_amt;
        if (this.$v.formLoanFPA_FT.$invalid) {} else {
          // let max = this.fpa_ft_loan.approved_loan_amt;
          // let loan = this.formLoanFPA_FT.loan_amount;
          // let min = 50000;
          // let max_php = this.thousands_separators(max);
          // let min_php = this.thousands_separators(min);
          // if (loan > max) {
          //   Swal.fire({
          //       icon: "info",
          //       title: "Reminder",
          //       html: `Maximum Loan: <b>Php ${max_php}</b>`,
          //       allowOutsideClick: false,
          //   }).then((response) => {
          //       this.formLoanFPA_FT.loan_amount = null;
          //   });
          // } else if (loan < min) {
          //   Swal.fire({
          //       icon: "info",
          //       title: "Reminder",
          //       html: `Minimum Loan: <b>Php ${min_php}</b>`,
          //       allowOutsideClick: false,
          //   }).then((response) => {
          //       this.formLoanFPA_FT.loan_amount = null;
          //   });
          // } else {}
          this.submittedFPA_FT = false;
            this.api.notif = true;
            axios
              .post("/api/c3-update-loan-fpa-ft", this.formLoanFPA_FT)
              .then((response) => {
                this.getUser();
                this.cancelModalLoanDetailFT();
                this.api.notif = false;
              })
              .catch((error) => {
                console.log(error);
              });
        }
      }, 333),
      getLoanFPA_FT(app_id) {
        this.api.notif = true;
        axios
          .get("api/c3-fpa-ft-loan", {
            params: {
              application_id: app_id,
            },
          })
          .then((response) => {
            let data = response.data;
            this.fpa_ft_loan = data.data;
            this.api.notif = false;
          })
          .catch((error) => {
            this.api.update = false;
            console.log(error);
          });
      },

      checkReasonFPA(doc) {
        let data = this.fpa_reason;
        let result = null;
        if (data.length > 0) {
          result = data.find((i) => i.doc_code == doc).reason;
        }
        return result;
      },

      downloadSworn() {
        this.api.update = true;
        axios
          .get("api/c3-dl-sworn-statement", {
            params: {
              borrower_id: this.formCSA.borrower_id,
              application_id: this.formCSA.application_id,
            },
            responseType: "blob",
          })
          .then((response) => {
            this.api.update = false;
            if (response.status == 204) {
              Swal.fire({
                icon: "warning",
                title: "File Not Found",
                allowOutsideClick: false,
                allowEscapeKey: false,
              });
            } else {
              let file = window.URL.createObjectURL(response.data);
              this.downloadFile(file, "Sworn-Statement.pdf");
            }
          })
          .catch((error) => {
            this.api.update = false;
            console.log(error);
          });
      },

      submitSwornStatement: _.debounce(function() {
        this.submittedSS = true;
        this.$v.formCSA.$touch();
        if (this.$v.formCSA.$invalid) {
          this.requiredField();
        } else {
          this.upload.DOC01 = true;
          const config = {
            headers: {
              "content-type": "multipart/form-data",
              "X-CSRF-TOKEN": document.querySelector('meta[name="csrf-token"]')
                .content,
            },
          };

          let formData = new FormData();
          formData.append("notif_id", this.formCSA.notif_id);
          formData.append("application_id", this.formCSA.application_id);
          formData.append("borrower_id", this.formCSA.borrower_id);
          formData.append("DOC01", this.formCSA.DOC01);

          axios
            .post("/api/upload-sworn-statement", formData, config)
            .then((response) => {
              this.upload.DOC01 = false;
              toast.fire({
                icon: "success",
                title: "File uploaded Successfully!",
              });
              $("#modalCSA").modal("hide");
              this.getUser();
              this.submittedSS = false;
            })
            .catch((error) => {
              this.upload.DOC05 = false;
              console.log(error);
            });
        }
      }, 200),

      downloadFile(fileURL, name) {
        const link = document.createElement("a");
        link.href = fileURL;
        link.setAttribute("download", name);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(fileURL);
      },

      closeModalForms() {
        $("#modalAppForm").modal("hide");
        for (let k in this.appForm) {
          this.appForm[k] = null;
        }
      },

      viewForms(app) {
        this.api.lr = true;
        axios
          .get("api/c3-dl-app-form", {
            params: {
              path: app.filepath,
              file: app.attach,
            },
            responseType: "blob",
          })
          .then((response) => {
            this.api.lr = false;
            if (response.status == 204) {
              Swal.fire({
                icon: "warning",
                title: "File Not Found",
                allowOutsideClick: false,
                allowEscapeKey: false,
              });
            } else {
              // this.appForm.url = window.URL.createObjectURL(response.data);
              // this.appForm.name = app.attach;
              // $('#modalAppForm').modal('show');

              const url = window.URL.createObjectURL(new Blob([response.data]));
              const link = document.createElement("a");
              link.href = url;
              link.setAttribute("download", "SBC-Application-Form.pdf");
              document.body.appendChild(link);
              link.click();
              link.remove();
              window.URL.revokeObjectURL(url);
            }
          })
          .catch((error) => {
            this.api.lr = false;
            console.log(error);
          });
      },

      getTransact(url = "/api/c3-transact") {
        this.tableData.borrower_id = this.formBorrower.borrower_id;
        this.api.transact = true;
        this.tableData.draw++;
        axios
          .get(url, {
            params: this.tableData,
          })
          .then((response) => {
            this.api.transact = false;
            let data = response.data;
            this.transact = data.data.data;
            this.configPagination(data.data);
          })
          .catch((error) => {
            this.api.transact = false;
            console.log(error);
          });
      },

      // table pagination and sorting
      resetPagination() {
        this.pagination.currentPage = 1;
        this.pagination.nextPageUrl = "";
        this.pagination.prevPageUrl = "";
      },
      configPagination(data) {
        this.pagination.lastPage = data.last_page;
        this.pagination.currentPage = data.current_page;
        this.pagination.total = data.total;
        this.pagination.lastPageUrl = data.last_page_url;
        this.pagination.nextPageUrl = data.next_page_url;
        this.pagination.prevPageUrl = data.prev_page_url;
        this.pagination.from = data.from;
        this.pagination.to = data.to;
      },
      sortBy(key) {
        this.sortKey = key;
        this.sortOrders[key] = this.sortOrders[key] * -1;
        this.tableData.column = this.getIndex(this.columns, "name", key);
        this.tableData.dir = this.sortOrders[key] === 1 ? "asc" : "desc";
        this.getTransact();
      },
      getIndex(array, key, value) {
        return array.findIndex((i) => i[key] == value);
      },

      modalPN(data, pnno) {
        this.lr_title = null;
        this.lr_docs = [];

        const grouped = _.groupBy(data, (item) => item.application_id);

        this.lr_docs = grouped;
        this.lr_title = pnno;
        // this.lr_application_id
        $("#modalPN").modal("show");
      },

      closeSSS13() {
        $("#modalSSS13").modal("hide");
        this.formSSS13.prn = null;
        this.formSSS13.ATT136 = null;
        document.getElementById("ATT136").value = "";
      },
      submitSSS13: _.debounce(function() {
        this.submittedSSS13 = true;

        this.$v.formSSS13.$touch();
        if (this.$v.formSSS13.$invalid) {
          this.requiredField();
        } else {
          this.upload.uploading = true;
          const config = {
            headers: {
              "content-type": "multipart/form-data",
              "X-CSRF-TOKEN": document.querySelector('meta[name="csrf-token"]')
                .content,
            },
            onUploadProgress: function(progressEvent) {}.bind(this),
          };

          let formData = new FormData();
          formData.append("doc_code", 43);
          formData.append("notif_id", this.notif_id);
          formData.append("application_id", this.application_id);
          formData.append("borrower_id", this.borrower_id);
          formData.append("prn", this.formSSS13.prn);
          formData.append("state_date", this.formSSS13.state_date);
          formData.append("no_workers", this.formSSS13.no_workers);
          formData.append("ATT136", this.formSSS13.ATT136);

          axios
            .post("/api/upload-sss13", formData, config)
            .then((response) => {
              this.upload.uploading = false;
              toast.fire({
                icon: "success",
                title: "Data updated Successfully!",
              });
              this.setStatusATT("ATT136");
              $("#modalSSS13").modal("hide");
            })
            .catch((error) => {
              this.upload.uploading = false;
              console.log(error);
            });

          this.submittedSSS13 = false;
        }
      }, 200),
      submitProofSale: _.debounce(function() {
        this.submittedPS = true;
        this.$v.formProofSale.$touch();
        if (this.$v.formProofSale.$invalid) {
          this.requiredField();
        } else {
          this.upload.DOC05 = true;
          const config = {
            headers: {
              "content-type": "multipart/form-data",
              "X-CSRF-TOKEN": document.querySelector('meta[name="csrf-token"]')
                .content,
            },
            onUploadProgress: function(progressEvent) {
              // this.progress.ATT12 = parseInt(Math.round((progressEvent.loaded * 100) / progressEvent.total)) + '%';
            }.bind(this),
          };

          let formData = new FormData();
          formData.append("doc_code", 31);
          formData.append("notif_id", this.formProofSale.notif_id);
          formData.append("application_id", this.formProofSale.application_id);
          formData.append("borrower_id", this.formProofSale.borrower_id);
          formData.append("DOC05", this.formProofSale.DOC05);

          axios
            .post("/api/upload-proof-sale-13th", formData, config)
            .then((response) => {
              this.upload.DOC05 = false;
              toast.fire({
                icon: "success",
                title: "File uploaded Successfully!",
              });
              $("#modalProofSale").modal("hide");
              this.getUser();
            })
            .catch((error) => {
              this.upload.DOC05 = false;
              console.log(error);
            });
        }
      }, 200),

      // checkMIME(file) {
      //     let type_img = ['image/jpeg', 'image/png', 'image/jpg', 'image/JPEG', 'image/PNG', 'image/JPG'];
      //     let type_pdf = ['application/pdf', 'application/PDF'];
      //     let type_video = ['video/MOV', 'video/mov', 'video/MPEG4', 'video/mpeg4', 'video/MP4', 'video/mp4', 'video/AVI', 'video/avi',
      //         'video/WMV', 'video/wmv', 'video/MPEGPS', 'video/mpegps', 'video/FLV', 'video/flv', 'video/3GPP', 'video/3ggp', 'video/3GP', 'video/3gp', 'video/HEVC',
      //         'video/hevc', 'video/WebM', 'video/wbem', 'video/DNxHR', 'video/dnxhr', 'video/ProRes', 'video/prores', 'video/CineForm', 'video/cineform'
      //     ];
      //     if (file['type']) {
      //         if (type_img.includes(file['type'])) {
      //             return 'img';
      //         }
      //         if (type_pdf.includes(file['type'])) {
      //             return 'pdf';
      //         }
      //         if (type_video.includes(file['type'])) {
      //             return 'video';
      //         }
      //     }
      // },
      // viewAttachFile(file, title) {
      //     this.attachFile.url = window.URL.createObjectURL(file);
      //     this.attachFile.type = this.checkMIME(file);
      //     this.attachFile.title = title;
      //     $('#modalView').modal('show');
      // },

      // closeATT(){
      //     window.URL.revokeObjectURL(this.attachFile.url);
      //     $('#modalView').modal('hide');
      // },

      attachSworn($event) {
        let file = $event.target.files[0];
        let fileType = [
          "image/jpeg",
          "image/png",
          "image/jpg",
          "application/pdf",
          "image/JPEG",
          "image/PNG",
          "image/JPG",
          "application/PDF",
        ];
        let fileSize = 1024 * 1024 * 10;
        if (file) {
          if (fileType.includes(file["type"])) {
            if (fileSize >= file["size"]) {
              this.formCSA.DOC01 = file;
            } else {
              this.formCSA.DOC01 = null;
              document.getElementById("doc01").value = "";
              Swal.fire({
                icon: "warning",
                title: "Info",
                text: "Exceeded the maximum file size required in IMG/PDF which is 10MB only",
                allowEscapeKey: false,
                allowOutsideClick: false,
              });
            }
          } else {
            this.invalidFileFormat();
            this.formCSA.DOC01 = null;
            document.getElementById("doc01").value = "";
          }
        } else {
          this.formCSA.DOC01 = null;
          document.getElementById("doc01").value = "";
        }
      },

      attachProfSale($event) {
        let file = $event.target.files[0];
        let fileType = [
          "image/jpeg",
          "image/png",
          "image/jpg",
          "application/pdf",
          "image/JPEG",
          "image/PNG",
          "image/JPG",
          "application/PDF",
        ];
        let fileSize = 1024 * 1024 * 10;
        if (file) {
          if (fileType.includes(file["type"])) {
            if (fileSize >= file["size"]) {
              this.formProofSale.DOC05 = file;
            } else {
              this.formProofSale.DOC05 = null;
              document.getElementById("prof_sale").value = "";
              Swal.fire({
                icon: "warning",
                title: "Info",
                text: "Exceeded the maximum file size required in IMG/PDF which is 10MB only",
                allowEscapeKey: false,
                allowOutsideClick: false,
              });
            }
          } else {
            this.invalidFileFormat();
            this.formProofSale.DOC05 = null;
            document.getElementById("prof_sale").value = "";
          }
        } else {
          this.formProofSale.DOC05 = null;
          document.getElementById("prof_sale").value = "";
        }
      },

      attachSSS13($event) {
        let file = $event.target.files[0];
        let fileType = [
          "image/jpeg",
          "image/png",
          "image/jpg",
          "application/pdf",
          "image/JPEG",
          "image/PNG",
          "image/JPG",
          "application/PDF",
        ];
        let fileSize = 1024 * 1024 * 10;
        if (file) {
          if (fileType.includes(file["type"])) {
            if (fileSize >= file["size"]) {
              this.formSSS13.ATT136 = file;
            } else {
              this.formSSS13.ATT136 = null;
              document.getElementById("ATT136").value = "";
              Swal.fire({
                icon: "warning",
                title: "Info",
                text: "Exceeded the maximum file size required in IMG/PDF which is 10MB only",
                allowEscapeKey: false,
                allowOutsideClick: false,
              });
            }
          } else {
            this.invalidFileFormat();
            this.formSSS13.ATT136 = null;
            document.getElementById("ATT136").value = "";
          }
        } else {
          this.formSSS13.ATT136 = null;
          document.getElementById("ATT136").value = "";
        }
      },

      closeModalProofSale() {
        this.formProofSale.DOC05 = null;
        document.getElementById("prof_sale").value = "";
        $("#modalProofSale").modal("hide");
      },
      submitStapleRelease() {
        this.submittedPS = true;
        this.$v.stapleRelease.$touch();
        if (this.$v.stapleRelease.$invalid) {
          this.requiredField();
        } else {
          this.submittedPS = false;
          this.api.notif = true;
          this.stapleRelease
            .post("/api/post-staple-release")
            .then((response) => {
              $("#modalStaple").modal("hide");
              this.getUser();
              this.api.notif = false;
            })
            .catch((error) => {
              console.log(error);
            });
        }
      },

      submitOdetteRelease() {
        this.submittedPS = true;
        this.$v.odetteRelease.$touch();
        if (this.$v.odetteRelease.$invalid) {
          this.requiredField();
        } else {
          this.submittedPS = false;
          this.api.notif = true;
          this.odetteRelease
            .post("/api/post-odette-release")
            .then((response) => {
              $("#modalOdette").modal("hide");
              this.getUser();
              this.api.notif = false;
            })
            .catch((error) => {
              console.log(error);
            });
        }
      },

      lrURL(path, file) {
        this.api.lr = true;
        axios
          .get("api/c3-dl-attach-lr", {
            params: {
              path: path,
              file: file,
            },
            responseType: "blob",
          })
          .then((response) => {
            this.api.lr = false;
            if (response.status == 204) {
              Swal.fire({
                icon: "warning",
                title: "File Not Found",
                // text: 'File Not Found',
                allowOutsideClick: false,
                allowEscapeKey: false,
              });
            } else {
              const url = window.URL.createObjectURL(new Blob([response.data]));
              const link = document.createElement("a");
              link.href = url;
              link.setAttribute("download", file);
              document.body.appendChild(link);
              link.click();
              link.remove();
              window.URL.revokeObjectURL(url);
            }
          })
          .catch((error) => {
            this.api.lr = false;
            console.log(error);
          });
      },

      getAttachLR(borrower_id) {
        this.api.lr = true;
        axios
          .get("api/c3-attach-lr", {
            params: {
              borrower_id: borrower_id,
            },
          })
          .then((response) => {
            this.api.lr = false;
            let data = response.data;

            if (data.esign.length > 0) {
              let esign = data.esign;
              const grouped = _.groupBy(esign, (item) => item.pnno_rel);
              this.esign_attach = grouped;
            }
            if (data.manual.length > 0) {
              let manual = data.manual;
              const grouped = _.groupBy(manual, (item) => item.pnno_rel);
              this.manual_attach = grouped;
            }
          })
          .catch((error) => {
            this.api.lr = false;
            console.log(error);
          });
      },

      updateAccount() {
        Swal.fire({
          title: "Are you sure?",
          text: "You won't be able to revert this!",
          icon: "warning",
          showCancelButton: true,
          cancelButtonText: "No",
          allowEscapeKey: false,
          allowOutsideClick: false,
        }).then((result) => {
          this.api.user = true;
          axios
            .post("api/db-update-user", {
              accounts: this.remain_detail,
              selected_id: this.selectedAccount[0].user_id,
              selected_bor_id: this.selectedAccount[0].borrower_id,
              selected_email: this.selectedAccount[0].email,
              borrower_id: this.borrower_id,
            })
            .then((response) => {
              this.api.user = false;

              if (this.formName.expiry_date) {
                let customDate = moment(this.formName.expiry_date, "MM/DD/YYYY");
                this.formName.s_expiry_date = customDate.format("YYYY-MM-DD");
              }

              if (this.formName.date_birth) {
                let customDate = moment(this.formName.date_birth, "MM/DD/YYYY");
                this.formName.s_birthdate = customDate.format("YYYY-MM-DD");
              }

              setTimeout(() => {
                this.updateProfile2();
              }, 700);
            })
            .catch((error) => {
              this.api.user = false;
              console.log(error);
            });
        });
      },

      selectedRow(e) {
        if (this.selectedAccount.length > 0) {
          this.remain_detail = JSON.parse(JSON.stringify(this.duplicates));
          this.remain_detail = this.remain_detail.filter(function(val) {
            return val.user_id !== e;
          });
        } else {
          this.remain_detail = [];
        }
      },

      isName(e) {
        let char = String.fromCharCode(e.keyCode); // Get the character
        if (/^[A-Za-z Ññ.'\-]+$/.test(char)) {
          return true; // Match with regex
        } else e.preventDefault(); // If not match, don't add to input text
      },

      getCity(val) {
        if (val) {
          this.api.city = true;
          axios
            .get("api/ref-prov-cities", {
              params: {
                province_code: val,
              },
            })
            .then((response) => {
              this.api.city = false;
              this.cities = response.data;
            })
            .catch((error) => {
              this.api.city = false;
              console.log(error);
            });
        }
      },
      getCity2(val) {
        if (val) {
          this.api.city = true;
          axios
            .get("api/ref-prov-cities", {
              params: {
                province_code: val,
              },
            })
            .then((response) => {
              this.api.city = false;
              this.cities2 = response.data;
            })
            .catch((error) => {
              this.api.city = false;
              console.log(error);
            });
        }
      },
      getBrgy2(val) {
        if (val) {
          this.api.brgy = true;
          axios
            .get("api/ref-city-brgy", {
              params: {
                city_code: val,
              },
            })
            .then((response) => {
              this.api.brgy = false;
              this.brgys2 = response.data;
            })
            .catch((error) => {
              this.api.brgy = false;
              console.log(error);
            });
        }
      },

      getProvince() {
        if (this.provinces.length == 0) {
          this.api.prov = true;
          axios
            .get("/api/ref-provinces")
            .then((response) => {
              this.api.prov = false;
              this.provinces = response.data;
            })
            .catch((error) => {
              this.api.prov = false;
              console.log(error);
            });
        }
      },
      getBrgy(val) {
        if (val) {
          this.api.brgy = true;
          axios
            .get("api/ref-city-brgy", {
              params: {
                city_code: val,
              },
            })
            .then((response) => {
              this.api.brgy = false;
              this.brgys = response.data;
            })
            .catch((error) => {
              this.api.brgy = false;
              console.log(error);
            });
        }
      },

      getExistLoan() {
        axios
          .get("api/exist-loan")
          .then((response) => {
            this.exist_loan = response.data;
          })
          .catch((error) => {
            console.log(error);
          });
      },

      showDetails(e) {
        this.guides2 = this.guides.find((i) => i.code === e);
        setTimeout(() => {
          $("#modalGuide").modal("show");
        }, 300);
      },

      ///////
      goApplyLoan() {
        this.$router.push("/apply-loan");
      },

      goProfile() {
        this.$router.push("/profile");
      },

      initToggling() {
        if (this.notif.length > 0) {
          this.toggle.AR = true;
          this.toggle.TH = false;
        } else {
          this.toggle.AR = false;
          this.toggle.TH = true;
        }
      },

      toggling(key) {
        let obj = this.toggle;
        for (let k in obj) {
          obj[k] == obj[key] ? (obj[k] = obj[key]) : (obj[k] = false);
        }
        obj[key] = !obj[key];
      },

      requiredField() {
        Swal.fire({
          icon: "warning",
          title: "Validation",
          text: "Please fill-out all required fields",
          allowOutsideClick: false,
          allowEscapeKey: false,
        });
      },

      invalidFileFormat() {
        Swal.fire({
          icon: "warning",
          title: "Error",
          text: "You are uploading unsupported file format",
          allowEscapeKey: false,
          allowOutsideClick: false,
        });
      },

      viewATT(formATT, title) {
        if (formATT) {
          this.viewSelectedFile(formATT, title);
        }
      },

      viewSelectedFile(file, filename) {
        if (file["type"] == "application/pdf") {
          let win = open(
            "",
            "",
            "toolbar=no,location=no,directories=no,status=no,menubar=no,scrollbars=yes,resizable=yes"
          );
          let iframe = document.createElement("iframe");
          let title = document.createElement("title");
          let fileUrl = window.URL.createObjectURL(file);

          title.appendChild(document.createTextNode(filename));

          iframe.src = fileUrl;
          iframe.width = "100%";
          iframe.height = "100%";
          iframe.style.border = "none";

          win.document.head.appendChild(title);
          win.document.body.appendChild(iframe);
          win.document.body.style.margin = 0;
        } else {
          let fileURL = window.URL.createObjectURL(file);
          let winFeatures =
            "toolbar=no,location=no,directories=no,status=no,menubar=no,scrollbars=yes,resizable=yes";
          let win = window.open(fileURL, filename, winFeatures);

          win.onload = (event) => {
            setTimeout(() => (win.document.title = filename), 300);
          };
        }
      },

      setStatusATT(key) {
        let objectIndex = this.notif_detail.findIndex(
          (obj) => obj.attach_code == key
        );
        this.notif_detail[objectIndex].status = "CS02";
      },
      resetStatusATT(key) {
        let objectIndex = this.notif_detail.findIndex(
          (obj) => obj.attach_code == key
        );
        this.notif_detail[objectIndex].status = "CS01";
      },
      trimFilename(n, len) {
        let ext = n.substring(n.lastIndexOf(".") + 1, n.length).toLowerCase();
        let filename = n.replace("." + ext, "");
        if (filename.length <= len) {
          return n;
        }
        filename = filename.substr(0, len) + (n.length > len ? "[...]" : "");
        return filename + "." + ext;
      },
      invalidFileSizeVideo() {
        Swal.fire({
          icon: "warning",
          title: "Error",
          text: "Exceeded the maximum file size required in Video which is 110MB only",
          allowEscapeKey: false,
          allowOutsideClick: false,
        });
      },

      uploadVideo($event, formObj, key) {
        let file = $event.target.files[0];
        let size = 1024 * 1024 * 110;
        if (file) {
          if (this.fileVideo.includes(file["type"])) {
            if (file["size"] > size) {
              this.invalidFileSizeVideo();
              formObj[key] = null;
              this.labelATT[key] = "Choose a file...";
            } else {
              this.progress[key] = 0;
              formObj[key] = file;
              this.labelATT[key] = this.trimFilename(file.name, 8);
              this.resetStatusATT(key);
            }
          } else {
            this.invalidFileFormat();
            formObj[key] = null;
            this.labelATT[key] = "Choose a file...";
          }
        } else {
          formObj[key] = formObj[key];
          this.labelATT[key] = this.labelATT[key];
        }
      },

      uploadImgPdf($event, formObj, key) {
        let file = $event.target.files[0];
        if (file) {
          if (this.fileImagePdf.includes(file["type"])) {
            this.progress[key] = 0;
            formObj[key] = file;
            this.labelATT[key] = this.trimFilename(file.name, 8);
            this.resetStatusATT(key);
          } else {
            this.invalidFileFormat();
            formObj[key] = null;
            this.labelATT[key] = "Choose a file...";
          }
        } else {
          formObj[key] = formObj[key];
          this.labelATT[key] = this.labelATT[key];
        }
      },
      browseRef(id) {
        document.getElementById(id).click();
      },

      unmaskAcctNo() {
        let val = this.formBank.acctno;
        this.checkAcctNo = val.replace(/-|\s/g, "");
      },

      submitBankDet() {
        this.api.bank = true;
        this.formBank
          .post("api/db-update-bank")
          .then((response) => {
            this.api.bank = false;
            // this.setStatusATT('ATT115');
            // this.setStatusATT('ATT22');
          })
          .catch((error) => {
            this.api.bank = false;
            console.log(error);
          });
      },

      swalUpdateBank() {
        Swal.fire({
          title: "Success",
          text: "Proof of Bank/EMA successfully updated",
          icon: "success",
          allowEscapeKey: false,
          allowOutsideClick: false,
        });
      },
      swalUpdateCob() {
        Swal.fire({
          title: "Success",
          text: "Coborrower information successfully updated",
          icon: "success",
          allowEscapeKey: false,
          allowOutsideClick: false,
        });
      },

      syncUpdateBankDet: async function() {
        await this.submitBankDet();
        await this.postAttach();
        await $("#modalBank").modal("hide");
        await $("#modalBank2").modal("hide");
        await this.swalUpdateBank();
      },

      updateBankDet: _.debounce(function() {
        this.formBank.ATT115 = this.formATT.ATT115;
        this.formBank.ATT22 = this.formATT.ATT22;

        this.formBank.notif_id = this.notif_id;

        this.submittedBank = true;
        this.$v.formBank.$touch();
        if (this.$v.formBank.$invalid) {
          this.requiredField();
        } else {
          let val = this.formBank.acctno;
          let digits = val.replace(/-|\s/g, "");
          let manner_rel = this.formBank.manner_rel;
          let loan_amount = this.formBank.req_loan_amt;

          if (
            this.formBank.manner_rel == "GC" ||
            this.formBank.manner_rel == "PM"
          ) {
            this.formBank.bankname = null;
          }
          this.syncUpdateBankDet();
        }
      }, 200),

      uploadImage12(e) {
        let file = e.target.files[0];
        let reader = new FileReader();
        if (file && !this.fileImage.includes(file["type"])) {
          this.invalidFileFormat();
          this.formName.ATT12 = null;
        } else {
          if (file) {
            reader.onloadend = (file) => {
              this.formName.ATT12 = reader.result; //passing data to model
            };
            reader.readAsDataURL(file);
          }
        }
      },

      updateResidentialAddress() {
        this.api.update = true;
        const form = {
          borrower_id: this.formName.borrower_id,
          province_code: this.formName.province_code,
          city_code: this.formName.city_code,
          bcode: this.formName.bcode,
          bldg: this.formName.bldg,
          street_address: this.formName.street_address,
        };
        axios
          .post("/api/db-post-res-address", form)
          .then((res) => {
            this.api.update = false;
            this.updateProfile();
          })
          .catch((err) => {
            this.api.update = false;
          });
      },

      updateNameID() {
        this.submittedProfile = true;
        this.$v.formName.$touch();
        if (this.$v.formName.$invalid) {
          this.requiredField();
        } else {
          Swal.fire({
            title: "Are you sure?",
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            cancelButtonText: "No",
            allowEscapeKey: false,
            allowOutsideClick: false,
          }).then((result) => {
            if (result.value) {
              if (this.formName.expiry_date) {
                let customDate = moment(this.formName.expiry_date, "MM/DD/YYYY");
                this.formName.s_expiry_date = customDate.format("YYYY-MM-DD");
              }
              if (this.formName.date_birth) {
                let customDate = moment(this.formName.date_birth, "MM/DD/YYYY");
                this.formName.s_birthdate = customDate.format("YYYY-MM-DD");
              }
              if (this.formName.ATT12) {
                this.upload.ATT12 = true;
                const config = {
                  headers: {
                    "content-type": "multipart/form-data",
                    "X-CSRF-TOKEN": document.querySelector(
                      'meta[name="csrf-token"]'
                    ).content,
                  },
                  onUploadProgress: function(progressEvent) {
                    this.progress.ATT12 =
                      parseInt(
                        Math.round(
                          (progressEvent.loaded * 100) / progressEvent.total
                        )
                      ) + "%";
                  }.bind(this),
                };
                let formData = new FormData();
                formData.append("application_id", this.application_id);
                formData.append("borrower_id", this.borrower_id);
                formData.append("ATT12", this.formName.ATT12);

                this.api.update = true;
                axios
                  .post("api/c3-db-update-gov-id", formData, config)
                  .then((response) => {
                    this.upload.ATT12 = false;
                    this.api.update = false;

                    setTimeout(() => {
                      this.updateResidentialAddress();
                    }, 500);
                  })
                  .catch((error) => {
                    this.upload.ATT12 = false;
                    this.api.update = false;
                    console.log(error);
                  });
              }
            }
          });
        }
      },

      proceedUpdateProfile() {
        Swal.fire({
          title: "Success",
          text: "Your record has been updated",
          icon: "success",
          showCancelButton: false,
        }).then((result) => {
          if (result) {
            this.setStatusATT("ATT12");
            $("#modalProfile").modal("hide");
            Fire.$emit("UserUpdated");
          }
        });
      },

      logout() {
        axios
          .post("/logout")
          .then((response) => {
            window.location.href = "/login";
          })
          .catch((error) => {
            if (error.response.status === 419) {
              window.location.href = "/login";
            }
          });
      },

      updateProfile2() {
        this.api.update_profile = true;
        this.recordExist = false;

        if (this.formName.expiry_date) {
          let customDate = moment(this.formName.expiry_date, "MM/DD/YYYY");
          this.formName.s_expiry_date = customDate.format("YYYY-MM-DD");
        }

        if (this.formName.date_birth) {
          let customDate = moment(this.formName.date_birth, "MM/DD/YYYY");
          this.formName.s_birthdate = customDate.format("YYYY-MM-DD");
        }

        this.formName
          .post("api/db-update-profile")
          .then((response) => {
            this.api.update_profile = false;
            let data = response.data.updateRecord;
            this.duplicates = response.data.duplicate;
            this.ids = response.data.ids;

            if (data == false) {
              this.recordExist = true;
              $("#modalProfile").modal("show");
            }
            if (data == true) {
              this.setStatusATT("ATT12");
              $("#modalProfile").modal("hide");
              Fire.$emit("UserUpdated");

              if (this.user.id == this.selectedAccount[0].user_id) {
                this.routeBack2();
              } else {
                Swal.fire({
                  title: "Success",
                  text: 'Your record has been updated.  The system will be logging you out. Kindly login to your account using the email address you have chosen.  Click "Forgot my Email or Password?" link and select "I forgot my password" if you have forgotten your password for chosen email address.',
                  icon: "success",
                  showCancelButton: false,
                }).then((result) => {
                  if (result) {
                    this.logout();
                  }
                });
              }
            }
          })
          .catch((error) => {
            this.api.update_profile = false;
            console.log(error);
          });
      },

      updateProfile() {
        this.api.update_profile = true;
        this.recordExist = false;

        // if (this.formName.expiry_date) {
        //     let customDate = moment(this.formName.expiry_date, 'MM/DD/YYYY');
        //     this.formName.s_expiry_date = customDate.format('YYYY-MM-DD');
        // }

        // if (this.formName.date_birth) {
        //     let customDate = moment(this.formName.date_birth, 'MM/DD/YYYY');
        //     this.formName.s_date_birth = customDate.format('YYYY-MM-DD');
        // }

        this.formName
          .post("api/db-update-profile")
          .then((response) => {
            this.api.update_profile = false;
            let data = response.data.updateRecord;
            this.duplicates = response.data.duplicate;
            this.ids = response.data.ids;

            if (data == false) {
              this.recordExist = true;
              $("#modalProfile").modal("show");
            }
            if (data == true) {
              this.setStatusATT("ATT12");
              $("#modalProfile").modal("hide");
              Fire.$emit("UserUpdated");
              this.routeBack2();
            }
          })
          .catch((error) => {
            this.api.update_profile = false;
            console.log(error);
          });
      },

      syncUpdateCob: async function() {
        await this.postAttach();
        await this.updateCobDetails();
        await $("#modalCob").modal("hide");
        await this.swalUpdateCob();
      },

      updateCobDetails() {
        this.api.cob = true;
        this.formCob
          .post("api/db-update-cob")
          .then((response) => {
            this.api.cob = false;
            this.setStatusATT("ATT29");
          })
          .catch((error) => {
            this.api.cob = false;
            console.log(error);
          });
      },

      updateCob: _.debounce(function() {
        this.formCob.application_id = this.application_id;
        this.formCob.borrower_id = this.borrower_id;
        this.formCob.notif_id = this.notif_id;
        this.formCob.ATT29 = this.formATT.ATT29;

        this.submittedCob = true;
        this.$v.formCob.$touch();
        if (this.$v.formCob.$invalid) {
          this.requiredField();
        } else {
          this.syncUpdateCob();
        }
      }, 600),

      selectedMR() {
        this.formBank.bankname = "";
        this.formBank.acctno = "";
        this.formBank.acct_mobile = "";
      },
      getBanks() {
        if (this.data_banks.length == 0) {
          axios
            .get("/api/banks")
            .then((response) => {
              this.data_banks = response.data;
            })
            .catch((error) => {
              console.log(error);
            });
        }
      },

      getMannerRelease() {
        if (this.data_manner_rel.length == 0) {
          axios
            .get("/api/manner-release2")
            .then((response) => {
              this.data_manner_rel = response.data;
            })
            .catch((error) => {
              console.log(error);
            });
        }
      },
      getBankDetails() {
        this.api.bank = true;
        axios
          .get("api/db-bank-details", {
            params: {
              application_id: this.application_id,
            },
          })
          .then((response) => {
            this.api.bank = false;
            if (response.data.length > 0) {
              this.formBank.fill(response.data[0]);
            }
          })
          .catch((error) => {
            this.api.bank = false;
            console.log(error);
          });
      },

      getBusinessAddress() {
        this.bus_address = [];
        this.api.update = true;
        axios
          .get("api/db-business-address", {
            params: {
              borrower_id: this.borrower_id,
              application_id: this.application_id,
            },
          })
          .then((response) => {
            this.api.update = false;
            this.bus_address = response.data[0];
            setTimeout(() => {
              this.getProvince();
              this.getCity(this.bus_address.province_code);
              this.getBrgy(this.bus_address.city_code);
              $("#modalBusinessAdd").modal("show");
            }, 200);
          })
          .catch((error) => {
            this.api.update = false;
            console.log(error);
          });
      },

      updateBusAddress: _.debounce(function() {
        this.submittedBusAdd = true;
        this.$v.bus_address.$touch();
        if (this.$v.bus_address.$invalid) {
          this.requiredField();
        } else {
          this.api.update = true;
          axios
            .post("api/db-update-bus-address", {
              borrower_id: this.borrower_id,
              application_id: this.application_id,
              business_name: this.bus_address.business_name,
              bus_id: this.bus_address.id,
              notif_id: this.notif_id,
              doc_code: this.doc_code,
              bcode: this.bus_address.bcode,
              bldg: this.bus_address.bldg,
              street_address: this.bus_address.street_address,
            })
            .then((response) => {
              this.api.update = false;
              this.setStatusATT(this.business_file);
              $("#modalBusinessAdd").modal("hide");
              this.submittedBusAdd = false;
            })
            .catch((error) => {
              this.api.update = false;
              console.log(error);
            });
        }
      }, 200),

      getBusinessName() {
        this.api.update = true;
        axios
          .get("api/db-business-name", {
            params: {
              borrower_id: this.borrower_id,
              application_id: this.application_id,
            },
          })
          .then((response) => {
            this.api.update = false;
            this.bus_info = response.data[0];
            $("#modalBusiness").modal("show");
          })
          .catch((error) => {
            this.api.update = false;
            console.log(error);
          });
      },
      updateBusName: _.debounce(function() {
        this.formCob.application_id = this.application_id;
        this.formCob.notif_id = this.notif_id;

        this.submittedCob = true;
        this.$v.bus_info.$touch();
        if (this.$v.bus_info.$invalid) {
          this.requiredField();
        } else {
          this.api.update = true;
          axios
            .post("api/db-update-bus-name", {
              borrower_id: this.borrower_id,
              application_id: this.application_id,
              business_name: this.bus_info.business_name,
              bus_id: this.bus_info.id,
              notif_id: this.notif_id,
              doc_code: this.doc_code,
              bt_code: this.bt_code,
            })
            .then((response) => {
              this.api.update = false;
              this.setStatusATT(this.business_file);
              $("#modalBusiness").modal("hide");
            })
            .catch((error) => {
              this.api.update = false;
              console.log(error);
            });
        }
      }, 200),

      syncBankDetails: async function(e) {
        await this.getMannerRelease();
        await this.getBanks();
        await this.getBankDetails();

        if (e == "ATT115") {
          await $("#modalBank").modal("show");
        }
        if (e == "ATT22") {
          await $("#modalBank2").modal("show");
        }
      },

      routeBack2() {
        this.update_profile = false;
        this.$router.push({
          path: "dashboard",
          query: {
            a: this.application_id,
            b: this.borrower_id,
            n: this.notif_id,
          },
        });
        this.getNotif(this.formBorrower.borrower_id);
      },

      routeUpdateProfile() {
        this.update_profile = true;
        this.$router.push({
          path: "dashboard",
          query: {
            a: this.application_id,
            b: this.borrower_id,
            n: this.notif_id,
            u: this.update_profile,
          },
        });
      },

      getRefID() {
        if (this.data_IDtypes.length == 0) {
          this.api.id_types = true;
          axios
            .get("/api/type-of-id")
            .then((response) => {
              this.api.id_types = false;
              this.data_IDtypes = response.data;
            })
            .catch((error) => {
              this.api.id_types = false;
            });
        }
      },

      editModal2(e) {
        this.business_file = null;
        if (
          e == "ATT107" ||
          e == "ATT108" ||
          e == "ATT109" ||
          e == "ATT110" ||
          e == "ATT103" ||
          e == "ATT104" ||
          e == "ATT143" ||
          e == "ATT149"
        ) {
          let ATT = {
            ATT107: "9",
            ATT108: "10",
            ATT109: "11",
            ATT110: "12",
            ATT103: "14",
            ATT104: "15",
            ATT143: "70",
            ATT149: "58",
          };
          this.doc_code = ATT[e];
          this.business_file = e;
          this.getBusinessAddress();
        }
        if (e == "ATT136") {
          this.doc_code = "ATT136";
          $("#modalSSS13").modal("show");
        }
      },

      getResAddress() {
        this.api.update = true;
        axios
          .get("/api/db-res-address", {
            params: {
              borrower_id: this.borrower_id,
            },
          })
          .then((response) => {
            this.api.update = false;
            let data = response.data;
            if (data.length > 0) {
              this.formName.bcode = data[0].bcode;
              this.formName.bldg = data[0].bldg;
              this.formName.city_code = data[0].city_code;
              this.formName.province_code = data[0].province_code;
              this.formName.street_address = data[0].street_address;
              this.getCity2(data[0].province_code);
              this.getBrgy2(data[0].city_code);
            }
          })
          .catch((error) => {
            this.api.update = false;
            console.log(error);
          });
      },
      editModal(e) {
        this.business_file = null;
        if (e == "ATT12") {
          this.uploadRRF = false;
          this.recordExist = false;
          this.formName.borrower_id = this.borrower_id;
          this.formName.application_id = this.application_id;
          this.formName.notif_id = this.notif_id;

          this.formName.fname = this.formBorrower.fname;
          this.formName.lname = this.formBorrower.lname;
          this.formName.mname = this.formBorrower.mname;
          this.formName.suffix_code = this.formBorrower.suffix_code;
          this.formName.date_birth = this.formBorrower.date_birth;
          this.formName.email = this.formBorrower.email;

          this.formName.gender_id = this.formBorrower.gender_id;
          this.formName.cs_code = this.formBorrower.cs_code;

          this.formName.province_code_birth =
            this.formBorrower.province_code_birth;
          this.formName.place_birth = this.formBorrower.place_birth;

          this.formName.bt_code = this.bt_code;
          if (this.formName.date_birth) {
            this.formName.date_birth = moment(
              this.formName.date_birth,
              "YYYY-MM-DD hh:mm:ss"
            ).format("MM/DD/YYYY");
            this.date_birth = this.formName.date_birth;
          }
          this.getProvince();
          this.getCity(this.formName.province_code_birth);
          this.getRefID();
          this.getResAddress();
          this.routeUpdateProfile();
        }
        if (e == "ATT115" || e == "ATT22") {
          this.syncBankDetails(e);
        }
        if (e == "ATT29") {
          this.syncGetCobDetails();
        }

        if (
          e == "ATT107" ||
          e == "ATT108" ||
          e == "ATT109" ||
          e == "ATT110" ||
          e == "ATT103" ||
          e == "ATT104" ||
          e == "ATT143" ||
          e == "ATT149"
        ) {
          let ATT = {
            ATT107: "9",
            ATT108: "10",
            ATT109: "11",
            ATT110: "12",
            ATT103: "14",
            ATT104: "15",
            ATT143: "70",
            ATT149: "58",
          };
          this.doc_code = ATT[e];
          this.business_file = e;
          this.getBusinessName();
        }
        if (e == "ATT119") {
          this.bus_reg = "Cert. of DTI Business Name Registration";
          this.bus_reg_code = "ATT119";
          this.getBusReg();
        }
        if (e == "ATT120") {
          this.bus_reg = "SEC Certificate of Registration";
          this.bus_reg_code = "ATT120";
          this.getBusReg();
        }
        if (e == "ATT121") {
          this.bus_reg = "Cert. of Cooperative Development Authority";
          this.bus_reg_code = "ATT121";
          this.getBusReg();
        }
      },

      closeBusReg() {
        this.formATT[this.bus_reg_code] = null;
        this.formBus[this.bus_reg_code] = null;
        this.labelATT[this.bus_reg_code] = "Choose a file...";
        $("#modalBusReg").modal("hide");
      },

      postBusReg() {
        this.submitBus = true;
        this.formBus[this.bus_reg_code] = this.formATT[this.bus_reg_code];
        this.$v.formBus.$touch();

        if (this.$v.formBus.$invalid) {} else {
          let bus_date = moment(this.formBus.bus_reg_date, "MM/DD/YYYY").format(
            "YYYY-MM-DD"
          );;
          let bus_expiry = moment(this.formBus.bus_expiry, "MM/DD/YYYY").format(
            "YYYY-MM-DD"
          );

          let formData = new FormData();
          formData.append("borrower_id", this.formBus.borrower_id);
          formData.append("application_id", this.formBus.application_id);
          formData.append("bus_reg_place", this.formBus.bus_reg_city);
          formData.append("bus_reg_date", bus_date);


          formData.append("bus_expiry", bus_expiry);
          formData.append("bus_num", this.formBus.bus_num);
          formData.append("att_code", this.bus_reg_code);

          this.api.update = true;
          axios
            .post("/api/db-post-bus-reg", formData)
            .then((res) => {
              this.api.update = false;
              $("#modalBusReg").modal("hide");
              this.postAttach();
            })
            .catch((err) => {
              this.api.update = false;
            });
        }
      },

      getBusReg() {
        this.api.update = true;
        axios
          .get("api/db-business-reg", {
            params: {
              borrower_id: this.borrower_id,
              application_id: this.application_id,
            },
          })
          .then((response) => {
            this.api.update = false;
            let data = response.data[0];

            this.formBus.bus_reg_province = data.bus_reg_province;
            this.formBus.bus_reg_city = data.bus_reg_city;
            this.formBus.bus_reg_date = data.bus_reg_date;
            this.formBus.borrower_id = this.borrower_id;
            this.formBus.application_id = this.application_id;

            setTimeout(() => {
              if (this.formBus.bus_reg_date) {
                this.formBus.bus_reg_date = moment(
                  this.formBus.bus_reg_date,
                  "YYYY-MM-DD"
                ).format("MM/DD/YYYY");
                this.startDate = this.formBus.bus_reg_date;
              }
              this.reg_date = true;
              this.reg_expiry = true;
              this.getProvince();
              this.getCity(this.formBus.bus_reg_province);
              $("#modalBusReg").modal("show");
            }, 200);
          })
          .catch((error) => {
            this.api.update = false;
            console.log(error);
          });
      },

      syncSave: async function(event) {
        await this.postAttach();
        Swal.fire({
          icon: "success",
          // text: 'Successfully Saved.',
          title: "Saved!",
          allowEscapeKey: false,
          allowOutsideClick: false,
        });
      },
      saveTag() {
        this.syncSave();
      },

      resetObj(obj, val) {
        for (let k in obj) {
          obj[k] = val;
        }
      },
      routeBack() {
        this.resetObj(this.formATT, null);
        this.resetObj(this.fetchATT, null);
        this.resetObj(this.labelATT, "Choose a file...");
        this.resetObj(this.progress, 0);
        this.borrower_id = null;
        this.application_id = null;
        this.notif_id = null;
        this.for_settlement = false;
        this.$router.push("/dashboard");
        this.getBorrowerDetail();
      },

      compliedTag() {
        this.api.notif = true;
        axios
          .post("api/c3-db-update-dv", {
            borrower_id: this.borrower_id,
            application_id: this.application_id,
            notif_id: this.notif_id,
            for_settlement: this.for_settlement,
          })
          .then((response) => {
            this.api.notif = false;
            Swal.fire({
              icon: "success",
              text: "You successfully complied",
              title: "Success",
              allowEscapeKey: false,
              allowOutsideClick: false,
            }).then((result) => {
              if (result) {
                this.routeBack();
              }
            });
          })
          .catch((error) => {
            this.api.notif = false;
          });
      },
      syncSubmit: async function(event) {
        await this.postAttach();

        if (this.notif_detail.some((obj) => obj.status === "CS01")) {
          Swal.fire({
            icon: "warning",
            text: "Please complete all for compliance before submitting",
            title: "Reminder",
            allowEscapeKey: false,
            allowOutsideClick: false,
          });
        } else {
          await this.compliedTag();
        }
      },

      async syncSubmitFPA() {
        await this.postAttachFPA();
        let res = this.res_arr.indexOf(500) !== -1; //check array of uploads where status not equal to 500 (server error)
        if (!res) {
          if (this.notif_detail.some((obj) => obj.status === "CS01")) {
            Swal.fire({
              icon: "warning",
              text: "Please complete all for compliance before submitting",
              title: "Reminder",
              allowEscapeKey: false,
              allowOutsideClick: false,
            });
          } else {
            this.compliedTagFPA();
          }
        }
      },

      compliedTagFPA() {
        this.api.notif = true;
        axios
          .post("api/c3-db-update-fpa", {
            borrower_id: this.borrower_id,
            application_id: this.application_id,
            notif_id: this.notif_id,
          })
          .then((response) => {
            this.api.notif = false;
            Swal.fire({
              icon: "success",
              text: "You successfully complied",
              title: "Success",
              allowEscapeKey: false,
              allowOutsideClick: false,
            }).then((result) => {
              if (result) {
                this.routeBack();
              }
            });
          })
          .catch((error) => {
            this.api.notif = false;
          });
      },

      async postAttachFPA() {
        this.res_arr.splice(0, this.res_arr.length);
        for (let key in this.formATT) {
          if (this.formATT[key] && !this.fetchATT[key]) {
            let lookupATT = {
              ATT12: 1,
              ATT102: 2,
              ATT105: 3,
              ATT106: 4,
              ATT08: 5,
              ATT09: 6,
              ATT10: 7,
              ATT113: 8,
              ATT107: 9,
              ATT108: 10,
              ATT109: 11,
              ATT110: 12,
              ATT112: 13,
              ATT103: 14,
              ATT104: 15,
              ATT29: 16,
              ATT115: 17,
              DOC01: 18,
              ATT116: 19,
              ATT26: 20,
              ATT27: 21,
              ATT28: 22,
              ATT117: 23,
              ATT118: 24,
              ATT22: 25,
              ATT119: 26,
              ATT120: 27,
              ATT121: 28,
              ATT122: 29,
              ATT123: 30,
              ATT125: 31,
              ATT126: 32,
              ATT128: 33,
              ATT127: 34,
              ATT129: 35,
              ATT111: 36,
              ATT130: 37,
              ATT131: 38,
              ATT132: 39,
              ATT133: 40,
              ATT134: 41,
              ATT135: 42,
              ATT136: 43,
              ATT146:63,
              ATT143:70,
              ATT149:58
            };

            this.upload.uploading = true;
            const config = {
              headers: {
                "content-type": "multipart/form-data",
                "X-CSRF-TOKEN": document.querySelector('meta[name="csrf-token"]')
                  .content,
              },
              onUploadProgress: function(progressEvent) {
                this.progress[key] =
                  parseInt(
                    Math.round((progressEvent.loaded * 100) / progressEvent.total)
                  ) + "%";
              }.bind(this),
            };
            let formData = new FormData();
            formData.append("doc_code", lookupATT[key]);
            formData.append("upload_file", this.formATT[key]);
            formData.append("attach_code", key);

            formData.append("notif_id", this.notif_id);
            formData.append("application_id", this.application_id);
            formData.append("borrower_id", this.borrower_id);

            await axios
              .post("/api/v2-upload-attachments-fpa", formData, config)
              .then((res) => {
                this.setStatusATT(key);
                this.upload.uploading = false;
                this.res_arr.push(res.status);
              })
              .catch((err) => {
                this.upload.uploading = false;
                this.res_arr.push(err.response.status);
              });
          }
        }
      },

      syncSubmitFPA: async function(event) {
        await this.postAttachFPA();

        if (this.notif_detail.some((obj) => obj.status === "CS01")) {
          Swal.fire({
            icon: "warning",
            text: "Please complete all for compliance before submitting",
            title: "Reminder",
            allowEscapeKey: false,
            allowOutsideClick: false,
          });
        } else {
          await this.compliedTagFPA();
        }
      },

      submitTag: _.debounce(function(id) {
        if (id == 1) {
          this.syncSubmit();
        } else if (id == 8) {
          this.syncSubmitFPA();
        } else {
          return;
        }
      }, 333),

      postAttach: async function(event) {
        if (this.formATT.ATT12 && !this.fetchATT.ATT12) {
          this.upload.ATT12 = true;
          const config = {
            headers: {
              "content-type": "multipart/form-data",
              "X-CSRF-TOKEN": document.querySelector('meta[name="csrf-token"]')
                .content,
            },
            onUploadProgress: function(progressEvent) {
              this.progress.ATT12 =
                parseInt(
                  Math.round((progressEvent.loaded * 100) / progressEvent.total)
                ) + "%";
            }.bind(this),
          };
          let formData = new FormData();
          formData.append("doc_code", 1);
          formData.append("notif_id", this.notif_id);
          formData.append("application_id", this.application_id);
          formData.append("borrower_id", this.borrower_id);
          formData.append("ATT12", this.formATT.ATT12);

          await axios
            .post("api/db_att12", formData, config)
            .then((response) => {
              this.upload.ATT12 = false;
              this.fetchATT = Object.assign(this.fetchATT, response.data);

              this.formATT.ATT12 = "";
              this.setStatusATT("ATT12");
            })
            .catch((error) => {
              this.upload.ATT12 = false;
              console.log(error);
            });
        }

        if (this.formATT.ATT102 && !this.fetchATT.ATT102) {
          this.upload.ATT102 = true;
          const config = {
            headers: {
              "content-type": "multipart/form-data",
              "X-CSRF-TOKEN": document.querySelector('meta[name="csrf-token"]')
                .content,
            },
            onUploadProgress: function(progressEvent) {
              this.progress.ATT102 =
                parseInt(
                  Math.round((progressEvent.loaded * 100) / progressEvent.total)
                ) + "%";
            }.bind(this),
          };
          let formData = new FormData();
          formData.append("doc_code", 2);
          formData.append("notif_id", this.notif_id);
          formData.append("application_id", this.application_id);
          formData.append("borrower_id", this.borrower_id);
          formData.append("ATT102", this.formATT.ATT102);

          await axios
            .post("api/db_att102", formData, config)
            .then((response) => {
              this.upload.ATT102 = false;
              this.fetchATT = Object.assign(this.fetchATT, response.data);

              this.formATT.ATT102 = "";
              this.setStatusATT("ATT102");
            })
            .catch((error) => {
              this.upload.ATT102 = false;
              console.log(error);
            });
        }
        if (this.formATT.ATT103 && !this.fetchATT.ATT103) {
          this.upload.ATT103 = true;
          const config = {
            headers: {
              "content-type": "multipart/form-data",
              "X-CSRF-TOKEN": document.querySelector('meta[name="csrf-token"]')
                .content,
            },
            onUploadProgress: function(progressEvent) {
              this.progress.ATT103 =
                parseInt(
                  Math.round((progressEvent.loaded * 100) / progressEvent.total)
                ) + "%";
            }.bind(this),
          };
          let formData = new FormData();
          formData.append("doc_code", 14);
          formData.append("notif_id", this.notif_id);
          formData.append("application_id", this.application_id);
          formData.append("borrower_id", this.borrower_id);
          formData.append("ATT103", this.formATT.ATT103);

          await axios
            .post("api/db_att103", formData, config)
            .then((response) => {
              this.upload.ATT103 = false;
              this.fetchATT = Object.assign(this.fetchATT, response.data);

              this.formATT.ATT103 = "";
              this.setStatusATT("ATT103");
            })
            .catch((error) => {
              this.upload.ATT103 = false;
              console.log(error);
            });
        }

        if (this.formATT.ATT104 && !this.fetchATT.ATT104) {
          this.upload.ATT104 = true;
          const config = {
            headers: {
              "content-type": "multipart/form-data",
              "X-CSRF-TOKEN": document.querySelector('meta[name="csrf-token"]')
                .content,
            },
            onUploadProgress: function(progressEvent) {
              this.progress.ATT104 =
                parseInt(
                  Math.round((progressEvent.loaded * 100) / progressEvent.total)
                ) + "%";
            }.bind(this),
          };
          let formData = new FormData();
          formData.append("doc_code", 15);
          formData.append("notif_id", this.notif_id);
          formData.append("application_id", this.application_id);
          formData.append("borrower_id", this.borrower_id);
          formData.append("ATT104", this.formATT.ATT104);

          await axios
            .post("api/db_att104", formData, config)
            .then((response) => {
              this.upload.ATT104 = false;
              this.fetchATT = Object.assign(this.fetchATT, response.data);

              this.formATT.ATT104 = "";
              this.setStatusATT("ATT104");
            })
            .catch((error) => {
              this.upload.ATT104 = false;
              console.log(error);
            });
        }

        if (this.formATT.ATT105 && !this.fetchATT.ATT105) {
          this.upload.ATT105 = true;
          const config = {
            headers: {
              "content-type": "multipart/form-data",
              "X-CSRF-TOKEN": document.querySelector('meta[name="csrf-token"]')
                .content,
            },
            onUploadProgress: function(progressEvent) {
              this.progress.ATT105 =
                parseInt(
                  Math.round((progressEvent.loaded * 100) / progressEvent.total)
                ) + "%";
            }.bind(this),
          };
          let formData = new FormData();
          formData.append("doc_code", 3);
          formData.append("notif_id", this.notif_id);
          formData.append("application_id", this.application_id);
          formData.append("borrower_id", this.borrower_id);
          formData.append("ATT105", this.formATT.ATT105);

          await axios
            .post("api/db_att105", formData, config)
            .then((response) => {
              this.upload.ATT105 = false;
              this.fetchATT = Object.assign(this.fetchATT, response.data);

              this.formATT.ATT105 = "";
              this.setStatusATT("ATT105");
            })
            .catch((error) => {
              this.upload.ATT105 = false;
              console.log(error);
            });
        }

        if (this.formATT.ATT106 && !this.fetchATT.ATT106) {
          this.upload.ATT106 = true;
          const config = {
            headers: {
              "content-type": "multipart/form-data",
              "X-CSRF-TOKEN": document.querySelector('meta[name="csrf-token"]')
                .content,
            },
            onUploadProgress: function(progressEvent) {
              this.progressATT106 =
                parseInt(
                  Math.round((progressEvent.loaded * 100) / progressEvent.total)
                ) + "%";
            }.bind(this),
          };
          let formData = new FormData();
          formData.append("doc_code", 4);
          formData.append("notif_id", this.notif_id);
          formData.append("application_id", this.application_id);
          formData.append("borrower_id", this.borrower_id);
          formData.append("ATT106", this.formATT.ATT106);

          await axios
            .post("api/db_att106", formData, config)
            .then((response) => {
              this.upload.ATT106 = false;
              this.fetchATT = Object.assign(this.fetchATT, response.data);

              this.formATT.ATT106 = "";
              this.setStatusATT("ATT106");
            })
            .catch((error) => {
              this.upload.ATT106 = false;
              console.log(error);
            });
        }
        if (this.formATT.ATT107 && !this.fetchATT.ATT107) {
          this.upload.ATT107 = true;
          const config = {
            headers: {
              "content-type": "multipart/form-data",
              "X-CSRF-TOKEN": document.querySelector('meta[name="csrf-token"]')
                .content,
            },
            onUploadProgress: function(progressEvent) {
              this.progress.ATT107 =
                parseInt(
                  Math.round((progressEvent.loaded * 100) / progressEvent.total)
                ) + "%";
            }.bind(this),
          };
          let formData = new FormData();
          formData.append("doc_code", 9);
          formData.append("notif_id", this.notif_id);
          formData.append("application_id", this.application_id);
          formData.append("borrower_id", this.borrower_id);
          formData.append("ATT107", this.formATT.ATT107);

          await axios
            .post("api/db_att107", formData, config)
            .then((response) => {
              this.upload.ATT107 = false;
              this.fetchATT = Object.assign(this.fetchATT, response.data);

              this.formATT.ATT107 = "";
              this.setStatusATT("ATT107");
            })
            .catch((error) => {
              this.upload.ATT107 = false;
              console.log(error);
            });
        }
        if (this.formATT.ATT108 && !this.fetchATT.ATT108) {
          this.upload.ATT108 = true;
          const config = {
            headers: {
              "content-type": "multipart/form-data",
              "X-CSRF-TOKEN": document.querySelector('meta[name="csrf-token"]')
                .content,
            },
            onUploadProgress: function(progressEvent) {
              this.progress.ATT108 =
                parseInt(
                  Math.round((progressEvent.loaded * 100) / progressEvent.total)
                ) + "%";
            }.bind(this),
          };
          let formData = new FormData();
          formData.append("doc_code", 10);
          formData.append("notif_id", this.notif_id);
          formData.append("application_id", this.application_id);
          formData.append("borrower_id", this.borrower_id);
          formData.append("ATT108", this.formATT.ATT108);

          await axios
            .post("api/db_att108", formData, config)
            .then((response) => {
              this.upload.ATT108 = false;
              this.fetchATT = Object.assign(this.fetchATT, response.data);

              this.formATT.ATT108 = "";
              this.setStatusATT("ATT108");
            })
            .catch((error) => {
              this.upload.ATT108 = false;
              console.log(error);
            });
        }
        if (this.formATT.ATT109 && !this.fetchATT.ATT109) {
          this.upload.ATT109 = true;
          const config = {
            headers: {
              "content-type": "multipart/form-data",
              "X-CSRF-TOKEN": document.querySelector('meta[name="csrf-token"]')
                .content,
            },
            onUploadProgress: function(progressEvent) {
              this.progress.ATT109 =
                parseInt(
                  Math.round((progressEvent.loaded * 100) / progressEvent.total)
                ) + "%";
            }.bind(this),
          };
          let formData = new FormData();
          formData.append("doc_code", 11);
          formData.append("notif_id", this.notif_id);
          formData.append("application_id", this.application_id);
          formData.append("borrower_id", this.borrower_id);
          formData.append("ATT109", this.formATT.ATT109);

          await axios
            .post("api/db_att109", formData, config)
            .then((response) => {
              this.upload.ATT109 = false;
              this.fetchATT = Object.assign(this.fetchATT, response.data);

              this.formATT.ATT109 = "";
              this.setStatusATT("ATT109");
            })
            .catch((error) => {
              this.upload.ATT109 = false;
              console.log(error);
            });
        }
        if (this.formATT.ATT110 && !this.fetchATT.ATT110) {
          this.upload.ATT110 = true;
          const config = {
            headers: {
              "content-type": "multipart/form-data",
              "X-CSRF-TOKEN": document.querySelector('meta[name="csrf-token"]')
                .content,
            },
            onUploadProgress: function(progressEvent) {
              this.progress.ATT110 =
                parseInt(
                  Math.round((progressEvent.loaded * 100) / progressEvent.total)
                ) + "%";
            }.bind(this),
          };
          let formData = new FormData();
          formData.append("doc_code", 12);
          formData.append("notif_id", this.notif_id);
          formData.append("application_id", this.application_id);
          formData.append("borrower_id", this.borrower_id);
          formData.append("ATT110", this.formATT.ATT110);

          await axios
            .post("api/db_att110", formData, config)
            .then((response) => {
              this.upload.ATT110 = false;
              this.fetchATT = Object.assign(this.fetchATT, response.data);

              this.formATT.ATT110 = "";
              this.setStatusATT("ATT110");
            })
            .catch((error) => {
              this.upload.ATT110 = false;
              console.log(error);
            });
        }

        if (this.formATT.ATT08 && !this.fetchATT.ATT08) {
          this.upload.ATT08 = true;
          const config = {
            headers: {
              "content-type": "multipart/form-data",
              "X-CSRF-TOKEN": document.querySelector('meta[name="csrf-token"]')
                .content,
            },
            onUploadProgress: function(progressEvent) {
              this.progress.ATT08 =
                parseInt(
                  Math.round((progressEvent.loaded * 100) / progressEvent.total)
                ) + "%";
            }.bind(this),
          };
          let formData = new FormData();
          formData.append("doc_code", 5);
          formData.append("notif_id", this.notif_id);
          formData.append("application_id", this.application_id);
          formData.append("borrower_id", this.borrower_id);
          formData.append("ATT08", this.formATT.ATT08);

          await axios
            .post("api/db_att08", formData, config)
            .then((response) => {
              this.upload.ATT08 = false;
              this.fetchATT = Object.assign(this.fetchATT, response.data);

              this.formATT.ATT08 = "";
              this.setStatusATT("ATT08");
            })
            .catch((error) => {
              this.upload.ATT08 = false;
              console.log(error);
            });
        }

        if (this.formATT.ATT09 && !this.fetchATT.ATT09) {
          this.upload.ATT09 = true;
          const config = {
            headers: {
              "content-type": "multipart/form-data",
              "X-CSRF-TOKEN": document.querySelector('meta[name="csrf-token"]')
                .content,
            },
            onUploadProgress: function(progressEvent) {
              this.progress.ATT09 =
                parseInt(
                  Math.round((progressEvent.loaded * 100) / progressEvent.total)
                ) + "%";
            }.bind(this),
          };
          let formData = new FormData();
          formData.append("doc_code", 6);
          formData.append("notif_id", this.notif_id);
          formData.append("application_id", this.application_id);
          formData.append("borrower_id", this.borrower_id);
          formData.append("ATT09", this.formATT.ATT09);

          await axios
            .post("api/db_att09", formData, config)
            .then((response) => {
              this.upload.ATT09 = false;
              this.fetchATT = Object.assign(this.fetchATT, response.data);

              this.formATT.ATT09 = "";
              this.setStatusATT("ATT09");
            })
            .catch((error) => {
              this.upload.ATT09 = false;
              console.log(error);
            });
        }
        if (this.formATT.ATT10 && !this.fetchATT.ATT10) {
          this.upload.ATT10 = true;
          const config = {
            headers: {
              "content-type": "multipart/form-data",
              "X-CSRF-TOKEN": document.querySelector('meta[name="csrf-token"]')
                .content,
            },
            onUploadProgress: function(progressEvent) {
              this.progress.ATT10 =
                parseInt(
                  Math.round((progressEvent.loaded * 100) / progressEvent.total)
                ) + "%";
            }.bind(this),
          };
          let formData = new FormData();
          formData.append("doc_code", 7);
          formData.append("notif_id", this.notif_id);
          formData.append("application_id", this.application_id);
          formData.append("borrower_id", this.borrower_id);
          formData.append("ATT10", this.formATT.ATT10);

          await axios
            .post("api/db_att10", formData, config)
            .then((response) => {
              this.upload.ATT10 = false;
              this.fetchATT = Object.assign(this.fetchATT, response.data);

              this.formATT.ATT10 = "";
              this.setStatusATT("ATT10");
            })
            .catch((error) => {
              this.upload.ATT10 = false;
              console.log(error);
            });
        }

        if (this.formATT.ATT112 && !this.fetchATT.ATT112) {
          this.upload.ATT112 = true;
          const config = {
            headers: {
              "content-type": "multipart/form-data",
              "X-CSRF-TOKEN": document.querySelector('meta[name="csrf-token"]')
                .content,
            },
            onUploadProgress: function(progressEvent) {
              this.progress.ATT112 =
                parseInt(
                  Math.round((progressEvent.loaded * 100) / progressEvent.total)
                ) + "%";
            }.bind(this),
          };
          let formData = new FormData();
          formData.append("doc_code", 13);
          formData.append("notif_id", this.notif_id);
          formData.append("application_id", this.application_id);
          formData.append("borrower_id", this.borrower_id);
          formData.append("ATT112", this.formATT.ATT112);

          await axios
            .post("api/db_att112", formData, config)
            .then((response) => {
              this.upload.ATT112 = false;
              this.fetchATT = Object.assign(this.fetchATT, response.data);

              this.formATT.ATT112 = "";
              this.setStatusATT("ATT112");
            })
            .catch((error) => {
              this.upload.ATT112 = false;
              console.log(error);
            });
        }
        if (this.formATT.ATT113 && !this.fetchATT.ATT113) {
          this.upload.ATT113 = true;
          const config = {
            headers: {
              "content-type": "multipart/form-data",
              "X-CSRF-TOKEN": document.querySelector('meta[name="csrf-token"]')
                .content,
            },
            onUploadProgress: function(progressEvent) {
              this.progress.ATT113 =
                parseInt(
                  Math.round((progressEvent.loaded * 100) / progressEvent.total)
                ) + "%";
            }.bind(this),
          };
          let formData = new FormData();
          formData.append("doc_code", 8);
          formData.append("notif_id", this.notif_id);
          formData.append("application_id", this.application_id);
          formData.append("borrower_id", this.borrower_id);
          formData.append("ATT113", this.formATT.ATT113);

          await axios
            .post("api/db_att113", formData, config)
            .then((response) => {
              this.upload.ATT113 = false;
              this.fetchATT = Object.assign(this.fetchATT, response.data);

              this.formATT.ATT113 = "";
              this.setStatusATT("ATT113");
            })
            .catch((error) => {
              this.upload.ATT113 = false;
              this.formAttStatus.ATT113 = "AS03";
              console.log(error);
            });
        }

        if (this.formATT.ATT115 && !this.fetchATT.ATT115) {
          this.upload.ATT115 = true;
          const config = {
            headers: {
              "content-type": "multipart/form-data",
              "X-CSRF-TOKEN": document.querySelector('meta[name="csrf-token"]')
                .content,
            },
            onUploadProgress: function(progressEvent) {
              this.progress.ATT115 =
                parseInt(
                  Math.round((progressEvent.loaded * 100) / progressEvent.total)
                ) + "%";
            }.bind(this),
          };
          let formData = new FormData();
          formData.append("doc_code", 17);
          formData.append("notif_id", this.notif_id);
          formData.append("application_id", this.application_id);
          formData.append("borrower_id", this.borrower_id);
          formData.append("ATT115", this.formATT.ATT115);

          await axios
            .post("api/db_att115", formData, config)
            .then((response) => {
              this.upload.ATT115 = false;
              this.fetchATT = Object.assign(this.fetchATT, response.data);

              this.formATT.ATT115 = "";
              this.setStatusATT("ATT115");
            })
            .catch((error) => {
              this.upload.ATT115 = false;
              console.log(error);
            });
        }

        if (this.formATT.ATT29 && !this.fetchATT.ATT29) {
          this.upload.ATT29 = true;
          const config = {
            headers: {
              "content-type": "multipart/form-data",
              "X-CSRF-TOKEN": document.querySelector('meta[name="csrf-token"]')
                .content,
            },
            onUploadProgress: function(progressEvent) {
              this.progress.ATT29 =
                parseInt(
                  Math.round((progressEvent.loaded * 100) / progressEvent.total)
                ) + "%";
            }.bind(this),
          };
          let formData = new FormData();
          formData.append("doc_code", 16);
          formData.append("notif_id", this.notif_id);
          formData.append("application_id", this.application_id);
          formData.append("borrower_id", this.borrower_id);
          formData.append("ATT29", this.formATT.ATT29);

          await axios
            .post("api/db_att118", formData, config)
            .then((response) => {
              this.upload.ATT29 = false;
              this.fetchATT = Object.assign(this.fetchATT, response.data);

              this.formATT.ATT29 = "";
              this.setStatusATT("ATT29");
            })
            .catch((error) => {
              this.upload.ATT29 = false;
              console.log(error);
            });
        }
        if (this.formATT.DOC01 && !this.fetchATT.DOC01) {
          this.upload.DOC01 = true;
          const config = {
            headers: {
              "content-type": "multipart/form-data",
              "X-CSRF-TOKEN": document.querySelector('meta[name="csrf-token"]')
                .content,
            },
            onUploadProgress: function(progressEvent) {
              this.progress.DOC01 =
                parseInt(
                  Math.round((progressEvent.loaded * 100) / progressEvent.total)
                ) + "%";
            }.bind(this),
          };
          let formData = new FormData();
          formData.append("doc_code", 18);
          formData.append("notif_id", this.notif_id);
          formData.append("application_id", this.application_id);
          formData.append("borrower_id", this.borrower_id);
          formData.append("DOC01", this.formATT.DOC01);

          await axios
            .post("api/db_attdoc01", formData, config)
            .then((response) => {
              this.upload.DOC01 = false;
              this.fetchATT = Object.assign(this.fetchATT, response.data);

              this.formATT.DOC01 = "";
              this.setStatusATT("DOC01");

              this.for_settlement = true;
            })
            .catch((error) => {
              this.upload.DOC01 = false;
              console.log(error);
            });
        }

        if (this.formATT.ATT117 && !this.fetchATT.ATT117) {
          this.upload.ATT117 = true;
          const config = {
            headers: {
              "content-type": "multipart/form-data",
              "X-CSRF-TOKEN": document.querySelector('meta[name="csrf-token"]')
                .content,
            },
            onUploadProgress: function(progressEvent) {
              this.progress.ATT117 =
                parseInt(
                  Math.round((progressEvent.loaded * 100) / progressEvent.total)
                ) + "%";
            }.bind(this),
          };
          let formData = new FormData();
          formData.append("doc_code", 23);
          formData.append("notif_id", this.notif_id);
          formData.append("application_id", this.application_id);
          formData.append("borrower_id", this.borrower_id);
          formData.append("ATT117", this.formATT.ATT117);

          await axios
            .post("api/db_att117", formData, config)
            .then((response) => {
              this.upload.ATT117 = false;
              this.fetchATT = Object.assign(this.fetchATT, response.data);

              this.formATT.ATT117 = "";
              this.setStatusATT("ATT117");
            })
            .catch((error) => {
              this.upload.ATT117 = false;
              console.log(error);
            });
        }
        if (this.formATT.ATT118 && !this.fetchATT.ATT118) {
          this.upload.ATT118 = true;
          const config = {
            headers: {
              "content-type": "multipart/form-data",
              "X-CSRF-TOKEN": document.querySelector('meta[name="csrf-token"]')
                .content,
            },
            onUploadProgress: function(progressEvent) {
              this.progress.ATT118 =
                parseInt(
                  Math.round((progressEvent.loaded * 100) / progressEvent.total)
                ) + "%";
            }.bind(this),
          };
          let formData = new FormData();
          formData.append("doc_code", 24);
          formData.append("notif_id", this.notif_id);
          formData.append("application_id", this.application_id);
          formData.append("borrower_id", this.borrower_id);
          formData.append("ATT118", this.formATT.ATT118);

          await axios
            .post("api/db_att119", formData, config)
            .then((response) => {
              this.upload.ATT118 = false;
              this.fetchATT = Object.assign(this.fetchATT, response.data);

              this.formATT.ATT118 = "";
              this.setStatusATT("ATT118");
            })
            .catch((error) => {
              this.upload.ATT118 = false;
              console.log(error);
            });
        }

        // additional

        if (this.formATT.ATT119 && !this.fetchATT.ATT119) {
          this.upload.ATT119 = true;
          const config = {
            headers: {
              "content-type": "multipart/form-data",
              "X-CSRF-TOKEN": document.querySelector('meta[name="csrf-token"]')
                .content,
            },
            onUploadProgress: function(progressEvent) {
              this.progress.ATT119 =
                parseInt(
                  Math.round((progressEvent.loaded * 100) / progressEvent.total)
                ) + "%";
            }.bind(this),
          };
          let formData = new FormData();
          formData.append("doc_code", 26);
          formData.append("notif_id", this.notif_id);
          formData.append("application_id", this.application_id);
          formData.append("borrower_id", this.borrower_id);
          formData.append("ATT119", this.formATT.ATT119);

          await axios
            .post("api/db_att119_1", formData, config)
            .then((response) => {
              this.upload.ATT119 = false;
              this.fetchATT = Object.assign(this.fetchATT, response.data);

              this.formATT.ATT119 = "";
              this.setStatusATT("ATT119");
            })
            .catch((error) => {
              this.upload.ATT119 = false;
              console.log(error);
            });
        }

        if (this.formATT.ATT120 && !this.fetchATT.ATT120) {
          this.upload.ATT120 = true;
          const config = {
            headers: {
              "content-type": "multipart/form-data",
              "X-CSRF-TOKEN": document.querySelector('meta[name="csrf-token"]')
                .content,
            },
            onUploadProgress: function(progressEvent) {
              this.progress.ATT120 =
                parseInt(
                  Math.round((progressEvent.loaded * 100) / progressEvent.total)
                ) + "%";
            }.bind(this),
          };
          let formData = new FormData();
          formData.append("doc_code", 27);
          formData.append("notif_id", this.notif_id);
          formData.append("application_id", this.application_id);
          formData.append("borrower_id", this.borrower_id);
          formData.append("ATT120", this.formATT.ATT120);

          await axios
            .post("api/db_att120", formData, config)
            .then((response) => {
              this.upload.ATT120 = false;
              this.fetchATT = Object.assign(this.fetchATT, response.data);

              this.formATT.ATT120 = "";
              this.setStatusATT("ATT120");
            })
            .catch((error) => {
              this.upload.ATT120 = false;
              console.log(error);
            });
        }

        if (this.formATT.ATT121 && !this.fetchATT.ATT121) {
          this.upload.ATT121 = true;
          const config = {
            headers: {
              "content-type": "multipart/form-data",
              "X-CSRF-TOKEN": document.querySelector('meta[name="csrf-token"]')
                .content,
            },
            onUploadProgress: function(progressEvent) {
              this.progress.ATT121 =
                parseInt(
                  Math.round((progressEvent.loaded * 100) / progressEvent.total)
                ) + "%";
            }.bind(this),
          };
          let formData = new FormData();
          formData.append("doc_code", 28);
          formData.append("notif_id", this.notif_id);
          formData.append("application_id", this.application_id);
          formData.append("borrower_id", this.borrower_id);
          formData.append("ATT121", this.formATT.ATT121);

          await axios
            .post("api/db_att121", formData, config)
            .then((response) => {
              this.upload.ATT121 = false;
              this.fetchATT = Object.assign(this.fetchATT, response.data);

              this.formATT.ATT121 = "";
              this.setStatusATT("ATT121");
            })
            .catch((error) => {
              this.upload.ATT121 = false;
              console.log(error);
            });
        }
        if (this.formATT.ATT122 && !this.fetchATT.ATT122) {
          this.upload.ATT122 = true;
          const config = {
            headers: {
              "content-type": "multipart/form-data",
              "X-CSRF-TOKEN": document.querySelector('meta[name="csrf-token"]')
                .content,
            },
            onUploadProgress: function(progressEvent) {
              this.progress.ATT122 =
                parseInt(
                  Math.round((progressEvent.loaded * 100) / progressEvent.total)
                ) + "%";
            }.bind(this),
          };
          let formData = new FormData();
          formData.append("doc_code", 29);
          formData.append("notif_id", this.notif_id);
          formData.append("application_id", this.application_id);
          formData.append("borrower_id", this.borrower_id);
          formData.append("ATT122", this.formATT.ATT122);

          await axios
            .post("api/db_att122", formData, config)
            .then((response) => {
              this.upload.ATT122 = false;
              this.fetchATT = Object.assign(this.fetchATT, response.data);

              this.formATT.ATT122 = "";
              this.setStatusATT("ATT122");
            })
            .catch((error) => {
              this.upload.ATT122 = false;
              console.log(error);
            });
        }
        if (this.formATT.ATT123 && !this.fetchATT.ATT123) {
          this.upload.ATT123 = true;
          const config = {
            headers: {
              "content-type": "multipart/form-data",
              "X-CSRF-TOKEN": document.querySelector('meta[name="csrf-token"]')
                .content,
            },
            onUploadProgress: function(progressEvent) {
              this.progress.ATT123 =
                parseInt(
                  Math.round((progressEvent.loaded * 100) / progressEvent.total)
                ) + "%";
            }.bind(this),
          };
          let formData = new FormData();
          formData.append("doc_code", 30);
          formData.append("notif_id", this.notif_id);
          formData.append("application_id", this.application_id);
          formData.append("borrower_id", this.borrower_id);
          formData.append("ATT123", this.formATT.ATT123);

          await axios
            .post("api/db_att123", formData, config)
            .then((response) => {
              this.upload.ATT123 = false;
              this.fetchATT = Object.assign(this.fetchATT, response.data);

              this.formATT.ATT123 = "";
              this.setStatusATT("ATT123");
            })
            .catch((error) => {
              this.upload.ATT123 = false;
              console.log(error);
            });
        }

        if (this.formATT.ATT125 && !this.fetchATT.ATT125) {
          this.upload.ATT125 = true;
          const config = {
            headers: {
              "content-type": "multipart/form-data",
              "X-CSRF-TOKEN": document.querySelector('meta[name="csrf-token"]')
                .content,
            },
            onUploadProgress: function(progressEvent) {
              this.progress.ATT125 =
                parseInt(
                  Math.round((progressEvent.loaded * 100) / progressEvent.total)
                ) + "%";
            }.bind(this),
          };
          let formData = new FormData();
          formData.append("doc_code", 31);
          formData.append("notif_id", this.notif_id);
          formData.append("application_id", this.application_id);
          formData.append("borrower_id", this.borrower_id);
          formData.append("ATT125", this.formATT.ATT125);

          await axios
            .post("api/db_att125", formData, config)
            .then((response) => {
              this.upload.ATT125 = false;
              this.fetchATT = Object.assign(this.fetchATT, response.data);

              this.formATT.ATT125 = "";
              this.setStatusATT("ATT125");
            })
            .catch((error) => {
              this.upload.ATT125 = false;
              console.log(error);
            });
        }
        if (this.formATT.ATT126 && !this.fetchATT.ATT126) {
          this.upload.ATT126 = true;
          const config = {
            headers: {
              "content-type": "multipart/form-data",
              "X-CSRF-TOKEN": document.querySelector('meta[name="csrf-token"]')
                .content,
            },
            onUploadProgress: function(progressEvent) {
              this.progress.ATT126 =
                parseInt(
                  Math.round((progressEvent.loaded * 100) / progressEvent.total)
                ) + "%";
            }.bind(this),
          };
          let formData = new FormData();
          formData.append("doc_code", 32);
          formData.append("notif_id", this.notif_id);
          formData.append("application_id", this.application_id);
          formData.append("borrower_id", this.borrower_id);
          formData.append("ATT126", this.formATT.ATT126);

          await axios
            .post("api/db_att126", formData, config)
            .then((response) => {
              this.upload.ATT126 = false;
              this.fetchATT = Object.assign(this.fetchATT, response.data);

              this.formATT.ATT126 = "";
              this.setStatusATT("ATT126");
            })
            .catch((error) => {
              this.upload.ATT126 = false;
              console.log(error);
            });
        }

        if (this.formATT.ATT127 && !this.fetchATT.ATT127) {
          this.upload.ATT127 = true;
          const config = {
            headers: {
              "content-type": "multipart/form-data",
              "X-CSRF-TOKEN": document.querySelector('meta[name="csrf-token"]')
                .content,
            },
            onUploadProgress: function(progressEvent) {
              this.progress.ATT127 =
                parseInt(
                  Math.round((progressEvent.loaded * 100) / progressEvent.total)
                ) + "%";
            }.bind(this),
          };
          let formData = new FormData();
          formData.append("doc_code", 33);
          formData.append("notif_id", this.notif_id);
          formData.append("application_id", this.application_id);
          formData.append("borrower_id", this.borrower_id);
          formData.append("ATT127", this.formATT.ATT127);

          await axios
            .post("api/db_att127", formData, config)
            .then((response) => {
              this.upload.ATT127 = false;
              this.fetchATT = Object.assign(this.fetchATT, response.data);

              this.formATT.ATT127 = "";
              this.setStatusATT("ATT127");
            })
            .catch((error) => {
              this.upload.ATT127 = false;
              console.log(error);
            });
        }

        if (this.formATT.ATT26 && !this.fetchATT.ATT26) {
          this.upload.ATT26 = true;
          const config = {
            headers: {
              "content-type": "multipart/form-data",
              "X-CSRF-TOKEN": document.querySelector('meta[name="csrf-token"]')
                .content,
            },
            onUploadProgress: function(progressEvent) {
              this.progress.ATT26 =
                parseInt(
                  Math.round((progressEvent.loaded * 260) / progressEvent.total)
                ) + "%";
            }.bind(this),
          };
          let formData = new FormData();
          formData.append("doc_code", 20);
          formData.append("notif_id", this.notif_id);
          formData.append("application_id", this.application_id);
          formData.append("borrower_id", this.borrower_id);
          formData.append("ATT26", this.formATT.ATT26);

          await axios
            .post("api/db_att26", formData, config)
            .then((response) => {
              this.upload.ATT26 = false;
              this.fetchATT = Object.assign(this.fetchATT, response.data);

              this.formATT.ATT26 = "";
              this.setStatusATT("ATT26");
            })
            .catch((error) => {
              this.upload.ATT26 = false;
              console.log(error);
            });
        }
        if (this.formATT.ATT27 && !this.fetchATT.ATT27) {
          this.upload.ATT27 = true;
          const config = {
            headers: {
              "content-type": "multipart/form-data",
              "X-CSRF-TOKEN": document.querySelector('meta[name="csrf-token"]')
                .content,
            },
            onUploadProgress: function(progressEvent) {
              this.progress.ATT27 =
                parseInt(
                  Math.round((progressEvent.loaded * 270) / progressEvent.total)
                ) + "%";
            }.bind(this),
          };
          let formData = new FormData();
          formData.append("doc_code", 21);
          formData.append("notif_id", this.notif_id);
          formData.append("application_id", this.application_id);
          formData.append("borrower_id", this.borrower_id);
          formData.append("ATT27", this.formATT.ATT27);

          await axios
            .post("api/db_att27", formData, config)
            .then((response) => {
              this.upload.ATT27 = false;
              this.fetchATT = Object.assign(this.fetchATT, response.data);

              this.formATT.ATT27 = "";
              this.setStatusATT("ATT27");
            })
            .catch((error) => {
              this.upload.ATT27 = false;
              console.log(error);
            });
        }
        if (this.formATT.ATT28 && !this.fetchATT.ATT28) {
          this.upload.ATT28 = true;
          const config = {
            headers: {
              "content-type": "multipart/form-data",
              "X-CSRF-TOKEN": document.querySelector('meta[name="csrf-token"]')
                .content,
            },
            onUploadProgress: function(progressEvent) {
              this.progress.ATT28 =
                parseInt(
                  Math.round((progressEvent.loaded * 280) / progressEvent.total)
                ) + "%";
            }.bind(this),
          };
          let formData = new FormData();
          formData.append("doc_code", 22);
          formData.append("notif_id", this.notif_id);
          formData.append("application_id", this.application_id);
          formData.append("borrower_id", this.borrower_id);
          formData.append("ATT28", this.formATT.ATT28);

          await axios
            .post("api/db_att28", formData, config)
            .then((response) => {
              this.upload.ATT28 = false;
              this.fetchATT = Object.assign(this.fetchATT, response.data);

              this.formATT.ATT28 = "";
              this.setStatusATT("ATT28");
            })
            .catch((error) => {
              this.upload.ATT28 = false;
              console.log(error);
            });
        }

        if (this.formATT.ATT22 && !this.fetchATT.ATT22) {
          this.upload.ATT22 = true;
          const config = {
            headers: {
              "content-type": "multipart/form-data",
              "X-CSRF-TOKEN": document.querySelector('meta[name="csrf-token"]')
                .content,
            },
            onUploadProgress: function(progressEvent) {
              this.progress.ATT22 =
                parseInt(
                  Math.round((progressEvent.loaded * 100) / progressEvent.total)
                ) + "%";
            }.bind(this),
          };
          let formData = new FormData();
          formData.append("doc_code", 25);
          formData.append("notif_id", this.notif_id);
          formData.append("application_id", this.application_id);
          formData.append("borrower_id", this.borrower_id);
          formData.append("ATT22", this.formATT.ATT22);

          await axios
            .post("api/db_att22", formData, config)
            .then((response) => {
              this.upload.ATT22 = false;
              this.fetchATT = Object.assign(this.fetchATT, response.data);

              this.formATT.ATT22 = "";
              this.setStatusATT("ATT22");
            })
            .catch((error) => {
              this.upload.ATT22 = false;
              console.log(error);
            });
        }

        if (this.formATT.ATT26 && !this.fetchATT.ATT26) {
          this.upload.ATT26 = true;
          const config = {
            headers: {
              "content-type": "multipart/form-data",
              "X-CSRF-TOKEN": document.querySelector('meta[name="csrf-token"]')
                .content,
            },
            onUploadProgress: function(progressEvent) {
              this.progress.ATT26 =
                parseInt(
                  Math.round((progressEvent.loaded * 100) / progressEvent.total)
                ) + "%";
            }.bind(this),
          };
          let formData = new FormData();
          formData.append("doc_code", 20);
          formData.append("notif_id", this.notif_id);
          formData.append("application_id", this.application_id);
          formData.append("borrower_id", this.borrower_id);
          formData.append("ATT26", this.formATT.ATT26);

          await axios
            .post("api/db_att26", formData, config)
            .then((response) => {
              this.upload.ATT26 = false;
              this.fetchATT = Object.assign(this.fetchATT, response.data);

              this.formATT.ATT26 = "";
              this.setStatusATT("ATT26");
            })
            .catch((error) => {
              this.upload.ATT26 = false;
              console.log(error);
            });
        }
        if (this.formATT.ATT27 && !this.fetchATT.ATT27) {
          this.upload.ATT27 = true;
          const config = {
            headers: {
              "content-type": "multipart/form-data",
              "X-CSRF-TOKEN": document.querySelector('meta[name="csrf-token"]')
                .content,
            },
            onUploadProgress: function(progressEvent) {
              this.progress.ATT27 =
                parseInt(
                  Math.round((progressEvent.loaded * 100) / progressEvent.total)
                ) + "%";
            }.bind(this),
          };
          let formData = new FormData();
          formData.append("doc_code", 21);
          formData.append("notif_id", this.notif_id);
          formData.append("application_id", this.application_id);
          formData.append("borrower_id", this.borrower_id);
          formData.append("ATT27", this.formATT.ATT27);

          await axios
            .post("api/db_att27", formData, config)
            .then((response) => {
              this.upload.ATT27 = false;
              this.fetchATT = Object.assign(this.fetchATT, response.data);

              this.formATT.ATT27 = "";
              this.setStatusATT("ATT27");
            })
            .catch((error) => {
              this.upload.ATT27 = false;
              console.log(error);
            });
        }
        if (this.formATT.ATT28 && !this.fetchATT.ATT28) {
          this.upload.ATT28 = true;
          const config = {
            headers: {
              "content-type": "multipart/form-data",
              "X-CSRF-TOKEN": document.querySelector('meta[name="csrf-token"]')
                .content,
            },
            onUploadProgress: function(progressEvent) {
              this.progress.ATT28 =
                parseInt(
                  Math.round((progressEvent.loaded * 100) / progressEvent.total)
                ) + "%";
            }.bind(this),
          };
          let formData = new FormData();
          formData.append("doc_code", 22);
          formData.append("notif_id", this.notif_id);
          formData.append("application_id", this.application_id);
          formData.append("borrower_id", this.borrower_id);
          formData.append("ATT28", this.formATT.ATT28);

          await axios
            .post("api/db_att28", formData, config)
            .then((response) => {
              this.upload.ATT28 = false;
              this.fetchATT = Object.assign(this.fetchATT, response.data);

              this.formATT.ATT28 = "";
              this.setStatusATT("ATT28");
            })
            .catch((error) => {
              this.upload.ATT28 = false;
              console.log(error);
            });
        }

        if (this.formATT.ATT22 && !this.fetchATT.ATT22) {
          this.upload.ATT22 = true;
          const config = {
            headers: {
              "content-type": "multipart/form-data",
              "X-CSRF-TOKEN": document.querySelector('meta[name="csrf-token"]')
                .content,
            },
            onUploadProgress: function(progressEvent) {
              this.progress.ATT22 =
                parseInt(
                  Math.round((progressEvent.loaded * 100) / progressEvent.total)
                ) + "%";
            }.bind(this),
          };
          let formData = new FormData();
          formData.append("doc_code", 25);
          formData.append("notif_id", this.notif_id);
          formData.append("application_id", this.application_id);
          formData.append("borrower_id", this.borrower_id);
          formData.append("ATT22", this.formATT.ATT22);

          await axios
            .post("api/db_att22", formData, config)
            .then((response) => {
              this.upload.ATT22 = false;
              this.fetchATT = Object.assign(this.fetchATT, response.data);

              this.formATT.ATT22 = "";
              this.setStatusATT("ATT22");
            })
            .catch((error) => {
              this.upload.ATT22 = false;
              console.log(error);
            });
        }
      
        if (this.formATT.ATT143 && !this.fetchATT.ATT143) {
          this.upload.ATT143 = true;
          const config = {
            headers: {
              "content-type": "multipart/form-data",
              "X-CSRF-TOKEN": document.querySelector('meta[name="csrf-token"]')
                .content,
            },
            onUploadProgress: function(progressEvent) {
              this.progress.ATT143 =
                parseInt(
                  Math.round((progressEvent.loaded * 100) / progressEvent.total)
                ) + "%";
            }.bind(this),
          };
          let formData = new FormData();
          formData.append("doc_code", 70);
          formData.append("notif_id", this.notif_id);
          formData.append("application_id", this.application_id);
          formData.append("borrower_id", this.borrower_id);
          formData.append("ATT143", this.formATT.ATT143);

          await axios
            .post("api/db_att143", formData, config)
            .then((response) => {
              this.upload.ATT143 = false;
              this.fetchATT = Object.assign(this.fetchATT, response.data);

              this.formATT.ATT143 = "";
              this.setStatusATT("ATT143");
            })
            .catch((error) => {
              this.upload.ATT143 = false;
              console.log(error);
            });
        }

        if (this.formATT.ATT149 && !this.fetchATT.ATT149) {
          this.upload.ATT149 = true;
          const config = {
            headers: {
              "content-type": "multipart/form-data",
              "X-CSRF-TOKEN": document.querySelector('meta[name="csrf-token"]')
                .content,
            },
            onUploadProgress: function(progressEvent) {
              this.progress.ATT149 =
                parseInt(
                  Math.round((progressEvent.loaded * 100) / progressEvent.total)
                ) + "%";
            }.bind(this),
          };
          let formData = new FormData();
          formData.append("doc_code", 58);
          formData.append("notif_id", this.notif_id);
          formData.append("application_id", this.application_id);
          formData.append("borrower_id", this.borrower_id);
          formData.append("ATT149", this.formATT.ATT149);

          await axios
            .post("api/db_att149", formData, config)
            .then((response) => {
              this.upload.ATT149 = false;
              this.fetchATT = Object.assign(this.fetchATT, response.data);

              this.formATT.ATT149 = "";
              this.setStatusATT("ATT149");
            })
            .catch((error) => {
              this.upload.ATT149 = false;
              console.log(error);
            });
        }

        if (this.formATT.ATT154 && !this.fetchATT.ATT154) {
          this.upload.ATT154 = true;
          const config = {
            headers: {
              "content-type": "multipart/form-data",
              "X-CSRF-TOKEN": document.querySelector('meta[name="csrf-token"]')
                .content,
            },
            onUploadProgress: function(progressEvent) {
              this.progress.ATT154 =
                parseInt(
                  Math.round((progressEvent.loaded * 100) / progressEvent.total)
                ) + "%";
            }.bind(this),
          };
          let formData = new FormData();
          formData.append("doc_code", 73);
          formData.append("notif_id", this.notif_id);
          formData.append("application_id", this.application_id);
          formData.append("borrower_id", this.borrower_id);
          formData.append("ATT154", this.formATT.ATT154);

          await axios
            .post("api/db_att154", formData, config)
            .then((response) => {
              this.upload.ATT154 = false;
              this.fetchATT = Object.assign(this.fetchATT, response.data);

              this.formATT.ATT154 = "";
              this.setStatusATT("ATT154");
            })
            .catch((error) => {
              this.upload.ATT154 = false;
              console.log(error);
            });
        }
        if (this.formATT.ATT155 && !this.fetchATT.ATT155) {
          this.upload.ATT155 = true;
          const config = {
            headers: {
              "content-type": "multipart/form-data",
              "X-CSRF-TOKEN": document.querySelector('meta[name="csrf-token"]')
                .content,
            },
            onUploadProgress: function(progressEvent) {
              this.progress.ATT155 =
                parseInt(
                  Math.round((progressEvent.loaded * 100) / progressEvent.total)
                ) + "%";
            }.bind(this),
          };
          let formData = new FormData();
          formData.append("doc_code", 74);
          formData.append("notif_id", this.notif_id);
          formData.append("application_id", this.application_id);
          formData.append("borrower_id", this.borrower_id);
          formData.append("ATT155", this.formATT.ATT155);

          await axios
            .post("api/db_att155", formData, config)
            .then((response) => {
              this.upload.ATT155 = false;
              this.fetchATT = Object.assign(this.fetchATT, response.data);

              this.formATT.ATT155 = "";
              this.setStatusATT("ATT155");
            })
            .catch((error) => {
              this.upload.ATT155 = false;
              console.log(error);
            });
        }
        if (this.formATT.ATT156 && !this.fetchATT.ATT156) {
          this.upload.ATT156 = true;
          const config = {
            headers: {
              "content-type": "multipart/form-data",
              "X-CSRF-TOKEN": document.querySelector('meta[name="csrf-token"]')
                .content,
            },
            onUploadProgress: function(progressEvent) {
              this.progress.ATT156 =
                parseInt(
                  Math.round((progressEvent.loaded * 100) / progressEvent.total)
                ) + "%";
            }.bind(this),
          };
          let formData = new FormData();
          formData.append("doc_code", 75);
          formData.append("notif_id", this.notif_id);
          formData.append("application_id", this.application_id);
          formData.append("borrower_id", this.borrower_id);
          formData.append("ATT156", this.formATT.ATT156);

          await axios
            .post("api/db_att156", formData, config)
            .then((response) => {
              this.upload.ATT156 = false;
              this.fetchATT = Object.assign(this.fetchATT, response.data);

              this.formATT.ATT156 = "";
              this.setStatusATT("ATT156");
            })
            .catch((error) => {
              this.upload.ATT156 = false;
              console.log(error);
            });
        }

      },

      notifURL(n) {
        if (n.subj_id == 1) {
          this.notif_id = n.id;
          this.subj_id = n.subj_id;
          this.borrower_id = n.borrower_id;
          this.application_id = n.application_id;

          this.$router.push({
            path: "dashboard",
            query: {
              a: n.application_id,
              b: n.borrower_id,
              n: n.id,
              subj_id: n.subj_id,
            },
          });
          this.getNotifDetails(n.id, n.borrower_id, n.application_id, n.subj_id);
        } else if (n.subj_id == 4) {
          this.stapleRelease.application_id = n.application_id;
          this.stapleRelease.borrower_id = n.borrower_id;
          this.stapleRelease.subj_id = n.subj_id;
          this.stapleRelease.notif_id = n.id;

          $("#modalStaple").modal("show");
        } else if (n.subj_id == 2 || n.subj_id == 3) {
          this.$router.push("/loan-releasing?app=" + n.application_id);
        } else if (n.subj_id == 5) {
          this.formProofSale.application_id = n.application_id;
          this.formProofSale.borrower_id = n.borrower_id;
          this.formProofSale.subj_id = n.subj_id;
          this.formProofSale.notif_id = n.id;
          $("#modalProofSale").modal("show");
        } else if (n.subj_id == 6) {
          this.odetteRelease.application_id = n.application_id;
          this.odetteRelease.borrower_id = n.borrower_id;
          this.odetteRelease.subj_id = n.subj_id;
          this.odetteRelease.notif_id = n.id;

          $("#modalOdette").modal("show");
        } else if (n.subj_id == 7) {
          this.formCSA.application_id = n.application_id;
          this.formCSA.borrower_id = n.borrower_id;
          this.formCSA.subj_id = n.subj_id;
          this.formCSA.notif_id = n.id;

          $("#modalCSA").modal("show");
        } else if (n.subj_id == 8) {
          this.notif_id = n.id;
          this.subj_id = n.subj_id;
          this.borrower_id = n.borrower_id;
          this.application_id = n.application_id;

          this.$router.push({
            path: "dashboard",
            query: {
              a: n.application_id,
              b: n.borrower_id,
              n: n.id,
            },
          });
          this.getNotifDetails(n.id, n.borrower_id, n.application_id, n.subj_id);
        } else if (n.subj_id == 9) {
          this.formLoanFPA_FT.notif_id = n.id;
          this.formLoanFPA_FT.borrower_id = n.borrower_id;
          this.formLoanFPA_FT.application_id = n.application_id;

          this.getLoanFPA_FT(n.application_id);
          $("#modalLoanDetailFT").modal("show");
        } else {
          return;
        }
      },

      getReasonFPA(application_id) {
        this.api.notif = true;
        axios
          .get("api/c3-get-fpa-reason", {
            params: {
              application_id: application_id,
            },
          })
          .then((response) => {
            this.api.notif = false;
            this.fpa_reason = response.data.data;
          })
          .catch((error) => {
            this.api.notif = false;
            console.log(error);
          });
      },

      getNotifDetails(id, borrower_id, application_id, subj_id = null) {
        this.subj_id = subj_id;
        if (id && borrower_id) {
          this.api.notif = true;
          axios
            .get("api/c3-notif-details", {
              params: {
                id: id,
                borrower_id: borrower_id,
                application_id: application_id,
              },
            })
            .then((response) => {
              this.api.notif = false;
              this.notif_detail = response.data.details;
              this.bt_code = response.data.bus_type[0].bt_code;
              this.getReasonFPA(application_id);

              this.initToggling();
            })
            .catch((error) => {
              this.api.notif = false;
              console.log(error);
            });
        }
      },

      getNotif(id) {
        this.api.notif = true;
        this.notif = [];
        // this.subj_id = [];
        axios
          .get("api/c3-notif", {
            params: {
              borrower_id: id,
            },
          })
          .then((response) => {
            this.api.notif = false;

            if (response.data.length > 0) {
              this.notif = response.data;
              // this.subj_id = response.data[0].subj_id;
            }
            this.initToggling();
          })
          .catch((error) => {
            this.api.notif = false;
            console.log(error);
          });
      },

      syncGetCobDetails: async function() {
        await this.getRefID();
        await this.getCoborrowerRelation();
        await this.getCoborrowerInfo();
      },

      getCoborrowerInfo() {
        this.api.cob = true;
        axios
          .get("api/db-cob-details", {
            params: {
              borrower_id: this.borrower_id,
            },
          })
          .then((response) => {
            this.api.cob = false;
            if (response.data.length > 0) {
              this.formCob.fill(response.data[0]);
              setTimeout(() => {
                $("#modalCob").modal("show");
              }, 300);
            } else {
              setTimeout(() => {
                $("#modalCob").modal("show");
              }, 300);
            }
          })
          .catch((error) => {
            this.api.cob = false;
            console.log(error);
          });
      },
      getCoborrowerRelation() {
        if (this.data_relation.length == 0) {
          axios
            .get("/api/coborrower-relation")
            .then((response) => {
              this.data_relation = response.data;
            })
            .catch((error) => {
              console.log(error);
            });
        }
      },

      getUser() {
        this.api.user = true;
        axios
          .get("api/user")
          .then((response) => {
            this.api.user = false;
            this.user.fill(response.data);
            this.getBorrowerDetail();
            this.getExistLoan();
          })
          .catch((error) => {
            this.api.user = false;
            console.log(error);
          });
      },
      getLoanAppForm(id) {
        this.api.form = true;
        axios
          .get("api/db-app-form", {
            params: {
              borrower_id: id,
            },
          })
          .then((response) => {
            this.api.form = false;

            let data = response.data;

            this.forms = data;
            // if (response.data) {
            //     this.appForm.fill(response.data);
            // }
          })
          .catch((error) => {
            this.api.form = false;
            console.log(error);
          });
      },

      getBorrowerDetail() {
        this.api.bor_det = true;
        axios
          .get("api/c3-bor-profile")
          .then((response) => {
            this.api.bor_det = false;
            if (response.data.length > 0) {
              this.formBorrower.fill(response.data[0]);

              setTimeout(() => {
                this.getLoanAppForm(this.formBorrower.borrower_id);
                this.getNotif(this.formBorrower.borrower_id);
                this.getTransact();
                this.getAttachLR(this.formBorrower.borrower_id);
                // $("#palawan").modal("show");
              }, 500);
            }
          })
          .catch((error) => {
            this.api.bor_det = false;
            console.log(error);
          });
      },


      getSuffix() {
        this.api.bor_det = true;
        axios
          .get("api/suffix")
          .then((response) => {
            this.api.bor_det = false;
            this.suffix = response.data;
          })
          .catch((error) => {
            this.api.bor_det = false;
            console.log(error);
          });
      },

    },
    mounted() {
      // $(document).ready(() => {
      //   $("#palawan").modal("show");
      //   });

      $(document).on("show.bs.modal", ".modal", function() {
        const zIndex = 1040 + 10 * $(".modal:visible").length;
        $(this).css("z-index", zIndex);
        setTimeout(() =>
          $(".modal-backdrop")
          .not(".modal-stack")
          .css("z-index", zIndex - 1)
          .addClass("modal-stack")
        );
      });
    },

    created() {
      this.getSuffix();
      this.getUser();
      this.getNotifDetails(
        this.notif_id,
        this.borrower_id,
        this.application_id,
        this.subj_id
      );
    },

    computed: {
      convertedAmount() {
        let val = this.formLoanFPA_FT.loan_amount;
        if (val > 0) {
          let num_parts = val.toString().split(".");
          num_parts[0] = num_parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
          return num_parts.join(".");
        } else {
          return "";
        }
      },
      arrGracePeriod() {
        let arr = null;
        let app_id = this.formLoanFPA_FT.application_id;
        let suffix = app_id.slice(-2);
        let term = this.formLoanFPA_FT.loan_term;
        if (term) {
          switch (suffix) {
            case "FT":
            case "MP":
            case "TD":
            case "RT":
            case "RS":
              if (term > 12) {
                arr = [0, 3, 6, 12];
              } else {
                arr = [0, 3, 6];
              }
              break;
            case "RN":
            case "RT":
              switch (term) {
                case 12:
                  arr = [0, 3, 6];
                  break;
                case 24:
                  arr = [0, 3, 6, 9, 12];
                  break;
                case 36:
                  arr = [0, 3, 6, 9, 12, 15, 18];
                  break;
                case 48:
                  arr = [0, 3, 6, 9, 12, 15, 18, 21, 24];
                  break;
                default:
              }
              break;
            case "R3":
              if (term > 3) {
                arr = [0, 3];
              } else {
                arr = [0];
              }
              break;
            default:
          }
        }
        return arr;
      },
      arrLoanTerm() {
        let arr = null;
        let app_id = this.formLoanFPA_FT.application_id;
        let suffix = app_id.slice(-2);
        switch (suffix) {
          case "FT":
          case "MP":
          case "TD":
          case "CE":
            arr = [12, 24, 36];
            break;
          case "RN":
          case "RT":
            arr = [12, 24, 36, 48];
            break;
          case "RS":
            arr = [12, 24, 36, 48, 60];
            break;
          case "R3":
            arr = [3, 6, 12];
            break;
          default:
        }
        return arr;
      },

      borrowerName() {
        let name;
        let fname = this.formBorrower.fname;
        let mname = this.formBorrower.mname;
        let lname = this.formBorrower.lname;

        let suffix = this.formBorrower.suffix_desc;
        if (suffix) {
          name = fname + " " + mname + lname + " " + suffix;
        } else {
          name = fname + " " + mname + " " + lname;
        }
        return name;
      },

      processingAPI() {
        return Object.values(this.api).includes(true);
      },

      uploadingAPI() {
        return Object.values(this.upload).includes(true);
      },
      filteredMR() {
        let list = this.data_manner_rel;
        let amount = this.formBank.req_loan_amt;
        let filter = null;
        if (amount > 50000) {
          filter = list.filter(function(item) {
            return item.manner_rel_code == "FT" || item.manner_rel_code == "PN";
          });
          return filter;
        } else if (amount <= 30000) {
          return list;
        } else {
          filter = list.filter(function(item) {
            return (
              item.manner_rel_code == "FT" ||
              item.manner_rel_code == "PN" ||
              item.manner_rel_code == "IP"
            );
          });
          return filter;
        }
      },
      filteredBank() {
        let data_banks = this.data_banks;
        if (this.formBank.manner_rel == "IP") {
          let instapay_data = data_banks.filter(function(item) {
            return item.instapay == "Y";
          });
          return instapay_data;
        }

        if (this.formBank.manner_rel == "PN") {
          let pesonet_data = data_banks.filter(function(item) {
            return item.pesonet == "Y";
          });
          return pesonet_data;
        }

        if (this.formBank.manner_rel == "FT") {
          let bankname = [{
            bankname: "LAND BANK OF THE PHILIPPINES",
          }, ];
          return bankname;
        }
        if (this.formBank.manner_rel == "CC") {
          let ft_data = data_banks.filter(function(item) {
            return item.bankname == "LAND BANK OF THE PHILIPPINES";
          });
          return ft_data;
        }
      },
    },
  };
</script>





<style>
  /* Chrome, Safari, Edge, Opera */
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  input[type="number"] {
    -moz-appearance: textfield;
  }

  .btn-block {
    display: block;
    width: 100%;
  }

  .btn-info {
    color: #fff;
    background-color: #28a745;
    border-color: #28a745;
    cursor: pointer;
    margin: 0%;
    padding-bottom: 0;
  }

  .btn-info:hover {
    background-color: darkgreen;
    cursor: pointer;
  }

  .cursor {
    cursor: pointer;
  }

  .container-iframe {
    position: relative;
    width: 100%;
    height: 100%;
  }

  .responsive-iframe {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    width: 100%;
    height: 100%;
  }

  #overlay {
    bottom: 0;
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
    align-items: center;
    display: flex;
    justify-content: center;
    overflow: visible;
    z-index: 9999;
    position: fixed;
    background-color: rgba(255, 255, 255, 0.5);
    /* background-color: black; */
  }

  .spinner {
    position: fixed;
    height: 60px;
    width: 60px;
    border: 3px solid transparent;
    border-top-color: #f96f14;
    margin: auto;
    border-radius: 50%;
    animation: spin 2s linear infinite;
  }

  .spinner:before,
  .spinner:after {
    content: "";
    position: fixed;
    border: 3px solid transparent;
    border-radius: 50%;
  }

  .spinner:before {
    border-top-color: #39cc78;
    top: -12px;
    left: -12px;
    right: -12px;
    bottom: -12px;
    animation: spin 3s linear infinite;
  }

  .spinner:after {
    border-top-color: black;
    top: 6px;
    left: 6px;
    right: 6px;
    bottom: 6px;
    animation: spin 4s linear infinite;
  }

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }

    100% {
      transform: rotate(360deg);
    }
  }

  .spinner.hidden {
    animation: fadeOut 1s;
    animation-fill-mode: forwards;
  }

  @keyframes fadeOut {
    100% {
      opacity: 0;
      visibility: hidden;
    }
  }

  label {
    font-weight: 400 !important;
  }
</style>